import antdData from 'antd/lib/locale-provider/en_US'

const messages = {
  'esopTable.priceUpdateWarning.title': 'Potential price-change for other investments',
  'esopTable.priceUpdateWarning.content':
    'The price of some equity investments and conversions is calculated based on the fully-diluted number of shares, which just changed. Please adjust your equity investments and conversions if needed.',
  'esopTable.priceUpdateWarning.confirm': 'Yes',
  'esopTable.priceUpdateWarning.cancel': 'Cancel',

  'conversionInvestments.priceUpdateWarning.title': 'Potential price-change for equity investments',
  'conversionInvestments.priceUpdateWarning.content':
    'The price of some equity investments is calculated based on the number of shares received from convertible notes in this round. Do you want to adjust the equity investments?',
  'conversionInvestments.priceUpdateWarning.confirm': 'Yes, show equity investments',
  'conversionInvestments.priceUpdateWarning.cancel': 'Cancel',

  'conversionPrice.info.title': 'Conversion Price',
  'conversionPrice.info.excerpt':
    'The conversion price is based on the agreed round price reduced by the discount and pre-money-cap parameters. ' +
    'The convertible note has a discount of <b>{discount}</b>, {preMoneyCapInfo} and {preMoneyFloorInfo}. ',
  'conversionPrice.info.noPreMoneyFloor': 'no pre-money-floor',
  'conversionPrice.info.preMoneyFloor': 'a floor at {preMoneyFloor} pre-money valuation',
  'conversionPrice.info.noPreMoneyCap': 'no pre-money-cap',
  'conversionPrice.info.preMoneyCap': 'a cap at {preMoneyCap} pre-money valuation',
  'conversionPrice.info.roundPrice':
    'Thus the conversion price equals the round price <b>{conversionPrice}</b> on the selected calculation basis.',
  'conversionPrice.info.preMoneyCapCalculation':
    '<br /><br />The effective discount of the pre-money-cap can be calculated: <br /> 1 - Pre-Money-Cap/Pre-Money-Valuation. <br />' +
    'In this round: <b>{preMoneyCapDiscount} = 1-({preMoneyCap}/{preMoneyValuation}).</b> <br />',
  'conversionPrice.info.preMoneyFloorCalculation':
    '<br /><br />The effective discount of the pre-money-cap can be calculated: <br /> 1 - Pre-Money-Floor/Pre-Money-Valuation. <br />' +
    'In this round: <b>{preMoneyFloorDiscount} = 1-({preMoneyFloor}/{preMoneyValuation}).</b> <br />',
  'conversionPrice.info.appliedPrice':
    '<br />The applied discount is <b>{appliedDiscount} based on the {appliedParameter}-Parameter.</b> <br /> ' +
    'This results in a conversion price: <b>{conversionPrice} = {roundPrice} * {discountMultiply}.</b> ',
  'conversionPrice.info.customPrice':
    '<br /><br />In this round a custom price was used: <b>{conversionPrice}.<b/>',

  'conversionInvestments.automaticShareCalculation':
    'Update discounted prices and shares automatically.',
  'investmentForm.defaultSharePrice': 'Update shares automatically based on {prices} price',
  'investmentForm.equity.automaticShareCalculation':
    'Update all shares automatically based on the share prices. ({prices})',

  // Default price calculation methods share/CN selection
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD': 'Fully Diluted',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND': 'Non Diluted',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD': 'Fully Diluted + Convertible',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND': 'Non Diluted + Convertible',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD': 'Reduced Pre-Money',
  'defaultPriceCalculationMethods.MANUAL_PRICE': 'MANUAL',

  // Price helper display in round
  'capTable.recap.preMoneyBasedPricePerShareND': 'Price (Non Diluted)',
  'capTable.recap.preMoneyBasedPricePerShareND.title': 'Price (Non Diluted)',
  'capTable.recap.preMoneyBasedPricePerShareND.excerpt':
    'The Pre-Money Price (Non Diluted) is calculated based on the <b>Pre-Money-Valuation</b> divided by the total number of <b>non diluted shares</b> (before round).' +
    'In this round: {preMoneyBasedPricePerShareND} = {preMoneyValuation} / {prevTotalNumberOfSharesND}.',

  'capTable.recap.avgPrice': 'Ø Price Paid',
  'capTable.recap.avgPrice.title': 'Ø Price Paid',
  'capTable.recap.avgPrice.excerpt':
    'The average price per share takes into account all <b>effectively paid prices for shares.</b> ' +
    'E.g. with consideration of discounts on convertible notes, but not considering dilution through a new V(E)SOP. <br /><br />' +
    'In this round: {averagePricePerShare} = {totalShareInvestments} / {totalNumberOfNewShares}.',

  'capTable.recap.preMoneyBasedPricePerShareFD': 'Price (Fully Diluted)',
  'capTable.recap.preMoneyBasedPricePerShareFD.title': 'Price (Fully Diluted)',
  'capTable.recap.preMoneyBasedPricePerShareFD.excerpt':
    'The Pre-Money Price (Fully Diluted) is calculated based on the <b>Pre-Money-Valuation</b> divided by the total number of <b>fully diluted shares</b> (before round).' +
    'V(E)SOP Shares created before or during the round (option "with price adjustment") are counted in. <br /><br />' +
    'In this round: {preMoneyBasedPricePerShareFD} = {preMoneyValuation} / {prevTotalNumberOfSharesFD}.',

  // Previous translations before 01.01.2022
  'investmentHistoryTrace.untriggeredEvents.title': 'Scheduled transactions (future)',
  'grantsOverview.grantsTable.columns.buttons.sharing.no-link': 'No access granted yet',
  'grantsOverview.grantsTable.columns.buttons.sharing.access-link': 'Access is still valid',
  'grantsOverview.grantsTable.columns.buttons.sharing.permanent-link': 'Permanent access granted',
  'grantsOverview.grantsTable.columns.buttons.sharing.expired-link': 'Access is expired',

  'employeeDashboard.preview.settings.labels.defaultExitAmount.isRequired':
    'Please enter a default exit amount',
  'employeeDashboard.preview.settings.labels.defaultExitDate.isRequired':
    'Please enter a default exit date',
  'employeeDashboard.preview.settings.labels.defaultExitDate': 'Default Exit-date',
  'employeeDashboard.preview.settings.labels.defaultExitAmount': 'Default Exit-amount',
  'employeeDashboard.preview.settings.labels.previewEmployee': 'Preview for employee',
  'employeeDashboard.preview.settings.headings.companyLogo': 'Company Logo',
  'employeeDashboard.preview.settings.headings.introText': 'Greeting text',
  'employeeDashboard.preview.settings.headings.customText': 'Your message',
  'employeeDashboard.preview.settings.headings.other': 'Other settings',

  'employeeDashboard.error.expired.heading': 'The access link is expired.',
  'employeeDashboard.error.expired.description':
    'Please contact your company to receive an updated link.',
  'employeeDashboard.error.expired.button': 'Register/Login',
  'employeeDashboard.error.overridden.heading':
    'The accessed link got overridden by a newer version and is invalid.',
  'employeeDashboard.error.overridden.description':
    'Please contact your company to receive an updated link.',
  'employeeDashboard.error.overridden.button': 'Register/Login',
  'employeeDashboard.error.revoked.heading': 'The accessed link got revoked and is invalid.',
  'employeeDashboard.error.revoked.description':
    'Please contact your company to receive an updated link.',
  'employeeDashboard.error.revoked.button': 'Register/Login',
  'employeeDashboard.error.general.heading': 'The access link is invalid.',
  'employeeDashboard.error.general.description':
    'Please contact your company to receive an updated link.',
  'employeeDashboard.error.general.button': 'Register/Login',

  'employeeDashboard.box.valuation.title': 'Your exit expectations',
  'employeeDashboard.box.valuation.description':
    'In order to be able to calculate a payout, a valuation must be determined at which the company is to be sold. Here you can enter a realistic value, but also a desired value. The diagram below will be updated on the basis of this value.',

  'employeeDashboard.box.intro.title': 'Dear {name},',
  'employeeDashboard.box.intro.description':
    'welcome to your individual V(E)SOP overview. Every single employee is important for the success of our company and should participate in its growth. That is why we have set up an options programme. Here you will find all the information you need about your employee options.',

  'employeeDashboard.box.info.title': 'What is V(E)SOP?',
  'employeeDashboard.box.info.description':
    'V(E)SOP is an abbrevation for “virtual employee stock option plan”.  This means that it simulates a real option plan, which allows employees to participate in equity capital without having to pay for the capital. It gives you the benefit of receiving a payment for the options if an “exercise event” takes place. How much your V(E)SOP participation could be worth depends on the company value.',
  'employeeDashboard.box.info.button': 'Learn the basics',

  'employeeDashboard.box.custom.title': 'Our message to you',
  'employeeDashboard.box.custom.description':
    'Here you will find an overview of all contracts that concern your V(E)SOP programme. The graph in the middle shows you how high the proceeds are for you in an exit case and how high the planned proceeds are. Often employee options are subject to a so-called vesting. If applicable, you will also find information on the current and future vesting of your options here. If you have any further questions, please do not hesitate to contact COMPANY_CONTACT.',
  'employeeDashboard.box.custom.footer': 'This message was sent by {companyName}.',

  'employeeDashboard.box.facts.title': 'Factsheet',
  'employeeDashboard.box.facts.subtitle1':
    'You have received a total of {numberOfGrants} option packages (grants).',
  'employeeDashboard.box.facts.subtitle2':
    'These packages are supposed to pay out about {totalPlannedValue} in an exit case.',
  'employeeDashboard.box.facts.fields.packages': 'Packages',
  'employeeDashboard.box.facts.fields.plannedProceeds': 'Planned proceeds',
  'employeeDashboard.box.facts.fields.packet': 'Package {idx}',
  'employeeDashboard.box.facts.fields.date': 'Allocation',
  'employeeDashboard.box.facts.fields.shareAmount': 'Options',
  'employeeDashboard.box.facts.fields.strikePrice': 'Strikeprice',
  'employeeDashboard.box.facts.fields.vesting': 'Vesting',
  'employeeDashboard.box.facts.fields.vestingMonths': '{months} months',

  'employeeDashboard.box.diagram.title': 'Possible proceeds',
  'employeeDashboard.box.diagram.options': '{options} Options',
  'employeeDashboard.box.diagram.labelX1': 'Vesting level as on',
  'employeeDashboard.box.diagram.labelX2': 'Valuation',
  'employeeDashboard.box.diagram.today': 'Today',
  'employeeDashboard.box.diagram.fullyVested': 'Fully vested',
  'employeeDashboard.box.diagram.totalPlanned': 'Total planned proceeds {totalPlannedValue}',

  'employeeDashboardPage.pathName': 'Employee Dashboard',
  'employeeLinkShareModal.title': 'Manage employee access',
  'grantsOverview.grantsTable.title.shareAccess': 'Manage employee access',
  'employeeLinkShareModal.tabs.accessTable': 'Share Access',
  'employeeLinkShareModal.tabs.preview': 'Preview',
  'employeeAccessTable.menu.grantAccess': 'Grant/Overwrite access',
  'employeeAccessTable.menu.revokeAccess': 'Revoke access',
  'employeeAccessTable.menu.permanent': 'Permanent',
  'employeeAccessTable.menu.expirationDate': 'Expiration date',
  'employeeAccessTable.table.headers.link': 'Link',
  'employeeAccessTable.table.headers.status': 'Status',
  'employeeAccessTable.table.headers.status.none': 'No invitation sent out yet',
  'employeeAccessTable.table.headers.status.permanent': 'Permanent access',
  'employeeAccessTable.table.headers.status.access': 'Access until {date}',
  'employeeAccessTable.table.headers.status.expired': 'Access expired on {date}',
  'employeeAccessTable.table.headers.mail.add': 'Add email address',
  'employeeAccessTable.table.footer.buttons.grant': 'Overwrite access for {number} employees',
  'employeeAccessTable.table.footer.buttons.revoke': 'Revoke access for {number} employees',
  'employeeAccessTable.table.headers.link.previewNewTab': 'Preview in new tab',
  'employeeAccessTable.table.filters.email.some': 'Accepted email',
  'employeeAccessTable.table.filters.email.none': 'Missing email',
  'employeeAccessTable.table.filters.link.some': 'Shared access',
  'employeeAccessTable.table.filters.link.none': 'No shared access',
  'employeeAccessTable.table.filters.status.none': 'No shared access',
  'employeeAccessTable.table.filters.status.expired': 'Expired access',
  'employeeAccessTable.table.filters.status.permanent': 'Permanent access',
  'employeeAccessTable.table.filters.status.access': 'Shared access',

  'cnConversionsTable.buttons.addMultiple': 'Convert multiple',
  'conversionInvestments.headers.totalAmount': 'Total converted amount',
  'conversionInvestments.importdata.title': 'Add/edit multiple conversions',
  'conversionInvestments.headers.conversionPrice': 'Discounted price',
  'conversionInvestments.headers.conversionPriceRequired':
    'Please enter a discounted price greater zero',
  'conversionInvestments.importdata.info.1':
    'In this table you can easily convert all the tranches of convertible notes',
  'conversionInvestments.importdata.info.2':
    'Please use the single transaction modal for more explanations and customization of the different parameters',
  'conversionInvestments.rules.nominalExceeds':
    'The converted nominal amount ({convertedNominal}) exceeds the available nominal amount ({nominal}).',
  'conversionInvestments.rules.interestExceeds':
    'The converted interest amount ({convertedInterest}) exceeds the available interest amount ({interest}).',

  'cnInvestments.importdata.title': 'Add/edit multiple convertible note investments',
  'cnInvestments.importdata.info.1':
    'In this table you can easily copy and paste all the tranches of convertible note investments for this financing round',
  'cnInvestments.importdata.info.2':
    'For more customization edit the tranchen details in the single transaction modal',
  'cnInvestments.importdata.info.3': 'Forgot to add a stakeholder?',

  'investmentForm.limitAsDatePlaceholder': 'Select the end date',
  'historyTrace.cnConversion.totalAmount.help':
    'The total amount consists of a conversion {conversionAmount} ({nominal} nominal and {interest} interest) and a {supplementaryAmount} supplementary payment amount.',
  'roundForm.futureDateDisallowed':
    'Dates in the future are disabled. You can use the modelling tool to plan ahead.',
  'grantsModelling.calculator.freePremiumTryOut':
    'You can use this premium feature for free for your first grant!',

  'grantsOverview.grantsTable.icons.rise': 'The actual package value exceeds the planned value',
  'grantsOverview.grantsTable.icons.fall': 'The actual package value is below the planned value',
  'grantsOverview.grantsTable.filters.plannedGreaterActual':
    'Total actual package value is smaller than planned value',
  'grantsOverview.grantsTable.filters.plannedApproxActual':
    'Total actual package value is approximately equal to planned value',
  'grantsOverview.grantsTable.filters.plannedSmallerActual':
    'Total actual package value is greater than planned value',
  'shareholder.add.employee.button': 'Add employee',
  'grantsOverview.grantsTable.columns.buttons.edit': 'Edit employee details',
  'grantsOverview.grantsTable.columns.buttons.modelling': 'Grant new package - to calculator',
  'grantsOverview.grantsTable.columns.plannedReturn': 'Planned return',
  'employee.add.modal.section.general': 'General',
  'employee.add.modal.section.compensationplanning': 'Compensation Planning',
  'employee.add.modal.title.edit': 'Employee Details',
  'employee.add.modal.title': 'Employee Details (New)',
  'grantsModelling.calculator.forms.form4.date': 'Granted date',

  'grantsOverview.exit.settings.accelerationOnExit': 'Acceleration of vesting',
  'grantsOverview.exit.settings.title': 'Exit settings to calculate actual package values',
  'grantsOverview.headerTable.title': 'V(E)SOPs Overview',
  'grantsOverview.grantsTable.title': 'Employee compensation',
  'grantsOverview.grantsTable.title.addEditEmployees': 'Add/Edit employees',
  'grantsOverview.grantsTable.columns.jobTitle': 'Job title',
  'grantsOverview.grantsTable.columns.salary': 'Salary p.a.',
  'grantsOverview.grantsTable.columns.options': 'Options today (Vested/Total)',
  'grantsOverview.grantsTable.columns.plannedPackage': 'Planned Package Values',
  'grantsOverview.grantsTable.columns.actualPackage': 'Actual Package Values',
  'grantsOverview.grantsTable.columns.status': 'Status',
  'grantsOverview.grantsTable.columns.status.vestingEnd': 'Vesting ends {end}',
  'grantsOverview.grantsTable.columns.status.none': 'None',
  'grantsOverview.grantsTable.columns.status.ongoing': 'Ongoing',
  'grantsOverview.grantsTable.columns.status.finished': 'Finished vesting',

  'grantsOverview.grantsTable.columns.pool': 'Pool',
  'grantsOverview.grantsTable.columns.optionsAtExit': 'Options at exit',
  'grantsOverview.grantsTable.columns.incAcceleration': 'inc. acceleration',
  'grantsOverview.grantsTable.columns.csOptionValue': 'Common share option <br />value at exit',
  'grantsOverview.grantsTable.columns.strikePrice': 'Strikeprice',
  'grantsOverview.grantsTable.columns.returnPerOption': 'Return per option',
  'grantsOverview.grantsTable.columns.returnTotal': 'Total Return',

  'grantsModelling.calculator.forms.form2.enablePackageValueInput':
    'Directly input planned package value',
  'shareholder.add.emplyoee.button': 'Add employee',
  'grantsModelling.calculator.forms.form2.example.title': 'Example case for equity compensation',
  'grantsModelling.calculator.forms.form2.example.info':
    'You have an employee with an annual salary of 50.000,00€. This person is your Lead UX Designer and the average salary is 65.000,00€. You want to incentivize this incentivize this employee for 4 years. You want to pay the salary loss of 15.000,00€ and a bonus.',
  'grantsModelling.calculator.header.steps.step1.button': 'Show example',
  'grantsModelling.calculator.forms.form2.example.text1': 'Current salary of the employee',
  'grantsModelling.calculator.forms.form2.example.text2': 'Bonus based on the current salary',
  'grantsModelling.calculator.forms.form2.example.text3': 'Salary compensation',
  'grantsModelling.calculator.forms.form2.example.text4': 'Planned incentivation period',
  'grantsModelling.calculator.forms.form2.example.text5':
    'Size of the package ({amount} per year x {years} years)',

  'grantsModelling.tabs.settings': 'Info & Settings',
  'grantsModelling.tabs.calculator': 'Calculator',
  'grantsModelling.settings.card.company.title': 'Exit expectations',
  'grantsModelling.settings.card.package.title': 'Variable Optionpackages (optional)',
  'grantsModelling.settings.form.postMoneyValuation': 'Last Post-Money-Valuation',
  'grantsModelling.settings.form.exitAmount': 'Expected exit-amount',
  'grantsModelling.settings.form.exitAmount.isRequired': 'Please enter an expected exit amount',
  'grantsModelling.settings.form.exitDate.isRequired': 'Please enter an exit date',
  'grantsModelling.settings.form.exitDate': 'Exit-Date',
  'grantsModelling.settings.form.roundPrice': 'Last round price',
  'grantsModelling.settings.form.csOptionValue': 'Expected exit proceeds per common share',
  'grantsModelling.settings.form.bonusCompensationLevels.name': 'Level',
  'grantsModelling.settings.form.bonusCompensationLevels.percentFromSalary': '% of salary',
  'grantsModelling.settings.info.welcome': 'Welcome to our V(E)SOP calculator',
  'grantsModelling.settings.info.list.title': 'Getting started',
  'grantsModelling.settings.info.list':
    'Here you set the two main factors to determine a fair equity-compensation strategy for your company',
  'grantsModelling.settings.info.list.item1': 'The expected exit potential for the company',
  'grantsModelling.settings.info.list.item2': 'How much % of the salary should be paid as equity',
  'grantsModelling.settings.card.company.info':
    'The exit expectation is important to evaluate the potential return for any options that you offer to employees. For example you might assume to triple your value in the next 4 years.',
  'grantsModelling.settings.card.package.info':
    'Dependent on the role of an employee you want can grant more/less % of the salary as equity-bonus. Here you can enter standardized values for different levels.',

  'grantsModelling.calculator.sidebar.steps.step1.title': 'Employee selection',
  'grantsModelling.calculator.sidebar.steps.step1.description': 'Select the beneficiary employee ',
  'grantsModelling.calculator.sidebar.steps.step2.title': 'Compensation package',
  'grantsModelling.calculator.sidebar.steps.step2.description':
    'Calculate the size of the compensation',
  'grantsModelling.calculator.sidebar.steps.step3.title': 'Strikeprice and options calculation',
  'grantsModelling.calculator.sidebar.steps.step3.description':
    'Calculate the value of the equity stake',
  'grantsModelling.calculator.sidebar.steps.step4.title': 'Pool selection',
  'grantsModelling.calculator.sidebar.steps.step4.description': 'Choose the backing pool',
  'grantsModelling.calculator.sidebar.steps.step5.title': 'Vesting (optional)',
  'grantsModelling.calculator.sidebar.steps.step5.description': 'Adjust the vesting schedule',
  'grantsModelling.calculator.header.steps.step1.info':
    'Start by choosing the employee you want to grant options for.',
  'grantsModelling.calculator.header.steps.step2.info':
    'Options can be used in different ways. As salary compensation, for possible bonus payments, or both together. The total package value is then calculated based on the incentivation duration.',
  'grantsModelling.calculator.header.steps.step3.info':
    'There are two ways to increase the value of the options-package. Either by allowing a lower strike price, or by increasing the number of options you grant to the employee. <br />Adjust the strike price and we will calculate you automatically the number of options required to compensate the option-package for the company valuation you provided in the setup (Normal case).',
  'grantsModelling.calculator.header.steps.step4.info':
    'Select the pool from which you want to grant the options.',
  'grantsModelling.calculator.header.steps.step5.info':
    'Optionally add a vesting schedule for the grants and finalize them.',
  'grantsModelling.calculator.footer.button.finish': 'Grant now',
  'grantsModelling.calculator.forms.form1.chooseEmployee': 'Choose an employee',
  'grantsModelling.calculator.forms.form2.salary': 'Salary p.a.',
  'grantsModelling.calculator.forms.form2.employeeLevel': 'MA-Level',
  'grantsModelling.calculator.forms.form2.bonusCompensation': 'Variable bonus p.a.',
  'grantsModelling.calculator.forms.form2.bonusCompensation.ofSalary': '{percent} of salary',
  'grantsModelling.calculator.forms.form2.salaryCompensation': 'Salary compensation p.a.',
  'grantsModelling.calculator.forms.form2.compensationPeriodInMonths':
    'Incentivation period (in months)',
  'grantsModelling.calculator.forms.form2.requiredOptionPackage': 'Planned Option-package value',
  'grantsModelling.calculator.forms.form3.strikeprice': 'Strikeprice',
  'grantsModelling.calculator.forms.form3.shareAmount': 'Number of options',
  'grantsModelling.calculator.forms.analysis.table.headers.worst': 'Worst',
  'grantsModelling.calculator.forms.analysis.table.headers.normal': 'Normal',
  'grantsModelling.calculator.forms.analysis.table.headers.best': 'Best',
  'grantsModelling.calculator.forms.analysis.table.headers.exitAmount': 'Exit',
  'grantsModelling.calculator.forms.analysis.table.headers.csOptionValue':
    'Common share options value',
  'grantsModelling.calculator.forms.analysis.table.headers.packageValue': 'Option-package value',
  'grantsModelling.calculator.forms.analysis.chart.labels.worst': 'Worst case',
  'grantsModelling.calculator.forms.analysis.chart.labels.normal': 'Normal case',
  'grantsModelling.calculator.forms.analysis.chart.labels.best': 'Best case',
  'grantsModelling.calculator.forms.analysis.chart.labels.packageValue': 'Package value at exit',
  'grantsModelling.calculator.forms.analysis.chart.labels.requiredPackageValue':
    'Planned Option-package value',

  'grantsModelling.calculator.forms.form4.shareAmount': 'Number of shares in option-package',
  'grantsModelling.calculator.forms.form4.esops': 'Pool selection',
  'grantsModelling.calculator.forms.form4.esops.table.available': 'Available',
  'grantsModelling.calculator.forms.form4.esops.table.options': 'Grant options',
  'grantsModelling.calculator.forms.form4.esops.table.optionsExceedMax':
    'The number of grant options exceeds the available options in the pool.',
  'grantsModelling.calculator.forms.form4.esops.table.optionsSumToTotal':
    'The total number of grant options needs to compensate the number of shares in option package',
  'grantsModelling.calculator.forms.form4.esops.table.availableAfter': 'Available afterwards',
  'grantsModelling.calculator.forms.form5.packageValue': 'Option-package value at expected exit',
  'grantsModelling.calculator.forms.form5.success.title': 'Successfully added grants',
  'grantsModelling.calculator.forms.form5.success.description':
    '{name} received {options} options for a strike price of {price}',

  'esopSetup.bonusCompensationLevels.normalEmployee': 'Normal employee',
  'esopSetup.bonusCompensationLevels.keyContributor': 'Key contributor',
  'esopSetup.bonusCompensationLevels.lead': 'Lead',
  'esopSetup.bonusCompensationLevels.headOfVP': 'Head of/VP',
  'grantsOverview.pathName': 'Grants overview',
  'grantModelling.pathName': 'Grant calculator',
  'modelling.analysis.investorBarCharts.shareQuota': 'Sharequota (FD)',

  'pageNotice.migrateUserInfo':
    'We are moving to a new chapter! Move with us to Gruenderplattform.de.',
  'pageNotice.cancelMigration':
    'I object to the data transfer. I am aware that the account will then be terminated by Ventury Analytics GmbH as of 15.09.2023, as announced in the email of 13.06.',
  'pageNotice.migrateUser': 'I agree',
  'pageNotice.migrateUserText': `I agree that my personal data (e.g. name, telephone number, e-mail address, address, customer number) as well as project data for communication regarding the operation of the platform and the project created on it may be sent to the company BusinessPilot GmbH
  Schlesische Street 32
  10997 Berlin , Germany will be transferred and processed.
  
  The data will not be passed on by the company BusinessPilot GmbH in any other way and will only be used for the proper operation of the platform.
  
  I am aware that I can revoke this consent at any time without giving reasons for the future by sending BusinessPilot GmbH by post Schlesische Straße 32
  10997 Berlin or by e-mail kontakt@businesspilot.de informing BusinessPilot GmbH of my revocation against the processing of my personal data.
  
  Upon consent, the complete account including the project will be transferred to Business Pilot GmbH. The platform can then continue to be used as usual.`,
  'pageNotice.joinProjects': 'Show all organization projects',
  'pageNotice.noProjectsButGroup': 'No Projects available.',
  'modellingPage.analysis.result.heading.scenarios': 'Results for comparison',
  'modellingPage.menu.top.helpDrawer.simple.step1.title': 'Add a new shareholders and shareclasses',
  'modellingPage.menu.top.helpDrawer.simple.step1.description':
    'In the topbar you can add new shareholders and shareclasses that can be used in the different scenarios you will create in the tree. Start by adding stakeholders that might invest in your company. If you are unsure, you can also keep it vague and just call them "New Investor X".',
  'modellingPage.menu.top.helpDrawer.simple.step2.title': 'Add a new financing round',
  'modellingPage.menu.top.helpDrawer.simple.step2.description':
    'Simply hover over a node in the tree on the left, in order to interact with it. Start by adding a subsequent round to your latest financing round.',
  'modellingPage.menu.top.helpDrawer.simple.step3.title': 'Input the round details',
  'modellingPage.menu.top.helpDrawer.simple.step3.description':
    'In the form that opens, you can enter all the round details. The forms are identical to your historical data input. Additionally, it allows you to add payout levels, such as a founder-catch-up, to fully customize each scenario.',
  'modellingPage.menu.top.helpDrawer.simple.step4.title': 'Show results',
  'modellingPage.menu.top.helpDrawer.simple.step4.description':
    'Hover over a node in the tree and select "Show details" to investigate the cap table and exit calculations for that scenario. Alternatively, you can go directly into the analysis section via the topbar. If you do not want to further edit the scenarios, we recommend to expand the analysis section to have a less crowded overview.',
  'modellingPage.menu.top.helpDrawer.simple.step5.title': 'Analysis Section',
  'modellingPage.menu.top.helpDrawer.simple.step5.description':
    'In the Analysis section on the right you have two tabs: "Details" and "Compare". In the "Details" tab you can investigate the cap table and exit calculations for a specific scenario. Note that you can switch between the "Cap table", "Waterfall" and "Exit calculation" tabs below the scenario selection menu. Further, you can customize the exit date for each scenario in the analysis section. By default it is one year past the scenario date. In the "Compare" tab you can compare the shareholder quota and exit returns of different stakeholders in different scenarios.',
  'modellingPage.menu.top.helpDrawer.simple.step6.title': 'Export your data',
  'modellingPage.menu.top.helpDrawer.simple.step6.description':
    'Lastly, you can export your data in a convenient excel format including most of the calculations. Just click on the download buttons in the analysis section or enter the export modal via the topbar.',

  'modellingPage.menu.top.export': 'Export',
  'shareclassTable.delete.isModellingProjectShare':
    'Your Project is shared or there are modelling projects created, which reference the share class. We want to ensure that all shareholders access the same data, thus you can not delete the share class from the project while there are modelling projects which reference it.',
  'termsheet.disableDelete.cnUsedInModelling':
    'Your Project is shared or there are modelling projects created, which reference the convertible note. We want to ensure that all shareholders access the same data, thus you can not delete the convertible note from the project while there are modelling projects which reference it.',
  'edit.canNotEdit':
    'Your Project is shared or there are modelling projects created, which reference the shareholder. ' +
    'We want to ensure that all shareholders access the same data, thus you can not delete the shareholder from the project while there are modelling projects which reference it.',

  'payouts.title': 'Payouts',
  'modellingProject.addNewRoundModal.title': 'Add/Edit a new financing round',
  'modellingProject.addShareclassModal.table.title':
    'Add new shareclasses which are used in the different scenarios',
  'modellingProject.addShareclassModal.title': 'Add/Edit new shareclasses',
  'shareclassTable.delete.isBaseProjectShare':
    'Only new shareclasses can be deleted in the modelling project.',
  'modellingPage.stakeholder.importdata.info.1':
    'Add new shareholders who can be used in the different scenarios.',
  'modellingPage.stakeholder.importdata.info.2':
    'Please note that you can only delete shareholders which do not have an investment in any scenario. Otherwise the deletion will not be saved permanently.',

  'modellingProjectTypes.SIMULATION': 'Complex Modelling Project',
  'modellingProjectTypes.CALCULATION': 'Simple Modelling Project',
  'modellingPage.updateProject.success.title': 'Successfully updated the modelling project',
  'modellingProjectForm.nameRequired': 'Please enter a name for the modelling project.',
  'modellingProjectForm.title': 'Change the name for your modelling project',
  'addModellingProjectTour.title': 'Add a new modelling project',
  'addModellingProjectTour.startModelling': 'Start modelling',
  'modellingProjectForm.type.calculation': 'Detailed planning',
  'modellingProjectForm.type.calculation.description':
    'This modus offers you fine-grained control about the scenarios you want to simulate in the same format that you are used to from your historical financing rounds. Create all possible scenarios in a tree and analyze & compare them directly. Note that this modus does offer less flexibility for unkown parameters, but is much easier to use and should be your first option at hand.',
  'modellingProjectForm.type.simulation': 'Strategy planning',
  'modellingProjectForm.type.simulation.description':
    'This modus offers you great flexibility to simulate a landscape of scenarios roughly. Input the basic parameters for each financing round such as total investment amount and date. For unkown parameters such as the valuation simply define a range (e.g. between 30-50mio) and filter & compare all outcomes. Note that this modus is harder to use and does not support detailed investments such as buyouts or partial conversions.',

  'modellingPage.deleteProject.confirm':
    'Are you sure you want to delete the modelling project {name}? This can not be undone.',
  'modellingPage.deleteProject.success.title': 'Successfully deleted the modelling project',
  'modellingPage.helpDrawer.title': 'Getting started',
  'modellingPage.menu.top.helpDrawer': 'Quick help',
  'modellingPage.menu.top.helpDrawer.complex.step1.title': 'Add a new financing round',
  'modellingPage.menu.top.helpDrawer.complex.step1.description':
    'Switch to the edit-mode by clicking on the "Editing" button in the topbar. Then simply click on a node in the tree on the left, in order to interact with it. Start by adding a subsequent round to your latest financing round.',
  'modellingPage.menu.top.helpDrawer.complex.step2.title': 'Input the round details',
  'modellingPage.menu.top.helpDrawer.complex.step2.description':
    'In the form that opens, you can enter all the round details. It also allows you to enter a range for parameters, e.g. if you do not know your exact valuation yet then you can enter a range and it will simulate all possible scenarios for you.',
  'modellingPage.menu.top.helpDrawer.complex.step3.title': 'Show results',
  'modellingPage.menu.top.helpDrawer.complex.step3.description':
    'Switch to the result-mode by clicking on the "Results" Button in the topbar. Click on a node in the tree and select "Show details" to investigate the cap table and exit calculations for that scenario. Alternatively, you can go directly into the analysis section via the topbar.',
  'modellingPage.menu.top.helpDrawer.complex.step4.title': 'Analysis Section',
  'modellingPage.menu.top.helpDrawer.complex.step4.description':
    'In the Analysis section on the right you have three tabs: Details, Compare and Filter. In the "Details" tab you can investigate the cap table and exit calculations for a specific scenario. In the "Compare" tab you can compare the shareholder quota and exit returns of different stakeholders in different scenarios. Lastly, the "Filter" tab can help you reduce the number of scenarios in the tree, to only keep realistic outcomes.',

  'projectsStats.filterBy.CREATED_DATE': 'Creation date',
  'projectsStats.filterBy.MODIFIED_DATE': 'Last edit',
  'usersStats.filterBy.CREATED_DATE': 'Signup',
  'usersStats.filterBy.MODIFIED_DATE': 'Login',

  'esop.editGrants': 'Add/Edit grants',
  'vestingModal.selectedPersons.confirmOverride':
    '{override}/{total} of the selected rows have already vesting schedules.<br /> Are you sure you want to override them?',
  'general.checkAGB':
    'I have read and agree with the <a href="https://ventury-analytics.de/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Service<a/>',
  'general.updatedAGB': 'We updated our Terms of Service, please read and accept them to continue.',
  'general.updatedAGBTitle': 'Terms of Service got updated',

  'newRound.pathName': 'Add new financing round',
  'newRound.steps.shareholder.name': 'Add new shareholders',
  'newRound.steps.shareholder.title': 'Add new shareholders',
  'newRound.steps.shareholder.subtitle': 'Any new shareholders that invested?',
  'newRound.steps.shareclass.name': 'Add a new shareclass',
  'newRound.steps.shareclass.title': 'Add a new shareclass',
  'newRound.steps.shareclass.subtitle': 'Which shareclass was bought?',
  'newRound.steps.newRound.name': 'Add new investments',
  'newRound.steps.newRound.title': 'Add a new financing round',
  'newRound.steps.newRound.subtitle': 'Include all equity and convertible note investments',
  'newRound.steps.finalCheck.name': 'Final Check',
  'newRound.steps.finalCheck.title': 'We are almost finished.',
  'newRound.steps.finalCheck.subtitle': "Let's check if all your data is correct.",

  'overview.esopBox.newEmployees': 'Add new employees',
  'overview.esopBox.grantOptions': 'Grant options of {esopName} to employees',
  'overview.esopBox.noEsopAdded': 'No esop has been created so far. Please click to setup a pool.',
  'overview.esopBox.addEsop': 'Add a new V(E)SOP',
  'overview.modellingBox.title': 'Model your future rounds, captables and scenarios',
  'overview.modellingBox.continueModelling': 'Continue modelling "{modellingName}"',
  'overview.modellingBox.addModelling': 'Start new modelling project',
  'overview.modellingBox.bodyTitle': 'Continue your Modelling Projects',
  'overview.modellingBox.bodySubtitle': 'Select an existing project or create a new one',
  'overview.modellingBox.initial.bodyTitle': 'Get started with your first modelling project!',
  'overview.modellingBox.initial.bodySubtitle':
    'A playground to simulate future scenarios and evaluate results',
  'overview.waterfallBox.title': 'Waterfall Calculation',
  'overview.waterfallBox.extendedAnalysis': 'Extended Analysis',
  'overview.waterfallBox.tableTitle': "Exit on today's basis",
  'overview.exportBox.title': 'Export your data',
  'overview.exportBox.header.export': 'Export',
  'overview.exportBox.header.round': 'Round',
  'overview.exportBox.header.date': 'Exit Date',
  'overview.exportBox.waterfall': 'Export Waterfall calculations',
  'overview.exportBox.capTables': 'Export Cap Tables',
  'overview.exportBox.transactionHistory': 'Export Transaction History',
  'overview.exportBox.consultingService':
    'Need help or additional services? Get in touch with our team!',

  'overview.esopBox.title': 'Manage your Employee Stock Option Plans',
  'overview.companyBox.lastRound': 'Last round: {roundName}',
  'overview.companyBox.title': 'Company Information of {companyName}',
  'overview.companyBox.newRound': 'Add a new financing round',
  'capTable.recap.roundDate': 'Round Date',
  'capTable.recap.shareholders': 'Shareholders',
  'overview.titleBox.morning': 'Good morning, {name}',
  'overview.titleBox.noon': 'Good noon, {name}',
  'overview.titleBox.afternoon': 'Good afternoon, {name}',
  'overview.titleBox.evening': 'Good evening, {name}',
  'overview.titleBox.seeWhatsHappening': 'See what is happening within "{companyName}"',
  'overview.updateBox.thingsTodo': 'Things still to do',
  'overview.updateBox.recentChanges': 'Most recent changes',
  'overview.updateBox.todos.continue': 'Continue to add your historical financing information',
  'overview.updateBox.todos.invite': 'Invite other stakeholders to easily keep them up-to-date',
  'overview.updateBox.todos.esop': 'Setup an employee stock option plan for your company',
  'overview.updateBox.todos.grant': 'Grant options to your employees',
  'overview.updateBox.todos.vesting': 'Add vesting schedules for founders or employees',
  'overview.updateBox.todos.documents': 'Upload your shareholder agreements for sharing',
  'overview.updateBox.todos.payouts': 'Add additional payout levels such as founder catch ups',
  'overview.updateBox.todos.allDone': 'All done. Nothing left todo.',

  'vestingTable.founders.title': 'Founder Vesting',
  'vestingTable.grants.title': 'Vesting of Grants',
  'vestingModal.founders.title': 'Add/Edit',
  'vestingModal.grants.title': 'Add/Edit',
  'vestingModal.newVestingSchedule.label': 'New vesting schedule',
  'vestingModal.selectedPersons.label': 'Select affected persons',
  'vestingModal.selectionTable.columns.name': 'Name',
  'vestingModal.selectionTable.columns.pool': 'Associated Pool',
  'vestingModal.selectionTable.columns.amountOfShares': 'Amount of shares',
  'vestingModal.selectionTable.columns.typeName': 'Type',
  'vestingModal.selectionTable.columns.roundName': 'Round',
  'vestingModal.selectionTable.columns.subjectToVesting': 'Already subject to a vesting plan',
  'vestingModal.founderVesting.percentUnderlyingVesting': 'Vesting basis',
  'vestingModal.founderVesting.percentUnderlyingVesting.suffix': 'of the {shareAmount}shares',
  'esop.defaultVestingSchedule.info':
    'In the following table, a default vesting schedule for your V(E)SOP pool can be created. It is automatically applied to all options which are issued for the pool. Of course, you can edit it subsequently for individual employees.',

  'esopGrant.exceltable.columns.shareAmount': 'No. Options',
  'esopGrant.exceltable.columns.expirationDate': 'Exp. Date',
  'esopGrant.exceltable.columns.strikePrice': 'Strike Price',
  'esopGrant.exceltable.columns.cliffPercent': 'Cliff %',
  'esopGrant.exceltable.columns.cliff': 'Cliff in months',
  'esopGrant.exceltable.columns.vestingPercent': 'Vesting %',
  'esopGrant.exceltable.columns.months': 'Vesting Duration (in months)',
  'esopGrant.exceltable.columns.vestingTime': 'Vests every x months',
  'esopGrant.exceltable.columns.accelerationOnExit': 'Acceleration',
  'esop.addGrants': 'Add grants',
  'esop.suffix': 'for {poolName}',
  'esopGrant.exceltable.rowErrorMsg':
    'Please provide a valid vesting schedule (fully filled w./w.o. cliff).',
  'esopGrant.excelmodal.showVesting': 'Show vesting schedules',
  'esopGrant.excelmodal.hideVesting': 'Hide vesting schedules',
  'esopGrant.exceltable.columns.complexVesting': 'Complex Vesting Schedule',
  'esopGrant.exceltable.validator.exceedsPoolsize':
    'The total of the entered grant options ({total}) exceed the size of the V(E)SOP ({poolSize}).',
  'esopGrant.exceltable.info.1':
    'Add all options which have been granted or will be granted. You can edit this information at any time.',
  'esopGrant.exceltable.info.2': 'Forgot to add an employee?',
  'esopGrant.exceltable.info.3':
    'The vesting schedule and strike price are filled with values from the last round price and esop default vesting schedule. You can add more advanced vesting schedules by editing the individual grants in the grant-table or on the vesting page.',
  here: 'here',
  'esopGrant.exceltable.validator.expirationDate':
    'The date needs to lie after the V(E)SOP creation ({esopDate}) and grant option issue ({grantDate}) dates.',
  'esopGrant.exceltable.validator.date':
    'The date needs to lie after the V(E)SOP creation date ({esopDate}).',

  'esop.planned': 'Planned',
  'esop.addEmployees': 'Add/Edit employees',
  'employee.importdata.info.1': 'Add, edit and delete employees of the company.',
  'employee.importdata.info.2': 'You can grant options to the employees and manage vesting plans.',
  'employee.importdata.info.3': 'Name is the only mandatory field.',
  'employee.importdata.title': 'Add/Edit employees',
  'esop.defaultVestingSchedule.label': 'Set default vesting schedule',
  'esop.defaultVestingSchedule.cliff': 'Cliff',
  'esop.defaultVestingSchedule.cliff.text1': ' after ',
  'esop.defaultVestingSchedule.cliff.text2': ' months.',
  'esop.defaultVestingSchedule.cliffPercent': 'Cliff percent',
  'esop.defaultVestingSchedule.cliffMonths': 'Cliff months',
  'esop.defaultVestingSchedule.columns.vestingPeriod': 'Vesting Period',
  'esop.defaultVestingSchedule.columns.percent': '%',
  'esop.defaultVestingSchedule.columns.months': 'Duration in months',
  'esop.defaultVestingSchedule.columns.vestingTime': 'Vests every x months',
  'esop.defaultVestingSchedule.validator.percentSum':
    'The total sum ({percentTotal}) of percent from vesting periods ({percentVesting}) and cliff ({percentCliff}) must be 100%',
  'esop.defaultVestingSchedule.validator.percent':
    'Please enter the percent of vested shares for the vesting period.',
  'esop.defaultVestingSchedule.validator.months': 'Please enter the vesting duration in months.',
  'esop.defaultVestingSchedule.validator.vestingTime':
    'Please enter how often the vesting applies.',

  'esopTable.title': 'V(E)SOPs',
  'manualSharesForm.date': 'Date of Deposit',
  'manualSharesForm.dateRequired': 'Please input a date',
  'cnConversionsTable.exceedsMaximum':
    'Conversion amounts exceeds total convertible note investment.',

  'buyOutForm.duplicateBuyOut':
    'There is already a buyout from this buyer for the specified seller, please adjust shares and price in the other row',
  'buyOutForm.buyerRequired': 'A buyer needs to be selected',
  'buyOutForm.sellerRequired': 'A seller needs to be selected',
  'buyOutForm.sameSellerAndBuyer': 'Please select a seller that differs to the buyer',
  'buyOutForm.buyingShareRequired': 'A bought shareclass needs to be selected',
  'buyOutForm.sellingShareRequired': 'A sold shareclass needs to be selected',
  'buyOutForm.buyingShare': 'Bought share',
  'buyOutForm.sellingShare': 'Sold share',
  'buyOutForm.numberOfSharesRequired': 'Please enter the number of shares that were bought',
  'buyOutForm.notEnoughShares':
    'The number ({sumOfBoughtShares}) of bought shares exceeds the number of shares ({numberOfShares}) owned by the seller from the sold share class.',
  'buyOutForm.pricePerShareRequired': 'Please enter the buying-price or simply insert 1.0',

  'buyOuts.importdata.title': 'Add/edit multiple buyouts',
  'buyOuts.importdata.info.1':
    'In this table you can easily enter or copy multiple buyouts for this financing round',
  'buyOuts.importdata.info.2': 'The required fields are marked with an asterisk (*)',
  'buyOuts.importdata.info.3': 'You can alter this information at any time later via the edit page',

  'manualShares.importdata.title': 'Add/edit multiple manual share entries',
  'manualShares.importdata.info.1':
    'In this table you can easily enter manual share entries for this financing round (e.g. for Anti-Dilution or other reductions)',
  'manualShares.importdata.info.2': 'The required fields are marked with an asterisk (*)',
  'manualShares.importdata.info.3':
    'You can alter this information at any time later via the edit page',

  'guidedTour.helpMenu.documentation': 'Documentation',
  'shareholder.importdata.title': 'Add/edit multiple shareholders',
  'equityInvestments.importdata.title': 'Add/edit multiple equity investments',
  'equityInvestments.importdata.info.1':
    'In this table you can easily copy and paste all your equity investments for this financing round',
  'equityInvestments.importdata.info.2': 'All fields are required',
  'equityInvestments.importdata.info.3': 'Forgot to add a stakeholder?',
  'importdata.info.justAddIt': 'Simply add it here',

  'investmentForm.preMoneyFloorVsCap':
    'The Pre-Money-Cap must be larger or equal than the Pre-Money-Floor parameter.',
  'investmentForm.investorRequired': 'An investor needs to be selected',
  'edit.pathName': 'Editing of Transaction History',
  'guidedTour.helpMenu.feedback': 'Give Feedback',
  'companyFormModal.title.add': 'Add Company',
  'companyFormModal.title.edit': 'Edit Company',
  back: 'Back',
  'roundForm.shareRequired': 'Please specify the share of the round',
  'transactionTables.transactionSelect.title': 'Transactions in this round',
  'edit.selectTermsheet.editRound': 'Edit round',

  'manualSharesTable.title': 'Manual Share Entries',
  'manualSharesTable.buttons.add': 'Add Manual Share Entry',
  'manualSharesForm.stakeholderRequired': 'Please select the stakeholder.',

  'buyoutsTable.title': 'Buyouts',
  'buyoutsTable.buttons.add': 'Add Buyout',
  'buyoutsTable.columns.headers.totalPaidAmount': 'Total paid amount',
  'buyoutsTable.columns.headers.shares': 'Shares',
  'buyoutsTable.exceedsMaximum': 'Buyout amount exceeds shares of the investor.',

  'cnConversionsTable.title': 'Convertible Loans',
  'cnConversionsTable.columns.headers.nominal': 'Convertible nominal',
  'cnConversionsTable.columns.headers.interest': 'Convertible interest',
  'cnConversionsTable.columns.headers.amount': 'Total convertible amount',
  'cnConversionsTable.columns.headers.amountOfShares': 'New Shares',
  'cnConversionsTable.buttons.showInterestCalc': 'Show Interest Calculations',
  'cnConversionsTable.buttons.edit': 'Edit',
  'cnConversionsTable.buttons.convert': 'Convert',
  'cnConversionsTable.buttons.convertAll': 'Convert all',
  'cnConversionsTable.buttons.convertNone': 'Undo conversions',

  'securities.shareclasses': 'Shareclasses',
  'cnInvestmentsTable.columns.headers.tranches': 'Tranches',
  'cnInvestmentsTable.columns.headers.interest': 'Interest',
  'cnInvestmentsTable.columns.headers.capAndDiscount': 'Cap/Discount',
  'cnInvestmentsTable.columns.text.cap': 'Cap',
  'cnInvestmentsTable.columns.text.floor': 'Floor',
  'cnInvestmentsTable.columns.text.discount': 'Discount',
  'shareholder.exceltable.columns.typeSuffix': '(e.g. Founder or Venture Capitalist)',
  'cnInvestmentsTable.buttons.add': 'Add CN Investment',
  'cnInvestmentsTable.buttons.edit': 'Edit CN Investment',
  'cnInvestmentsTable.title': 'Convertible Investments',

  // Translated
  'shareclassTable.delete.defaultOptions':
    'Common shares and options are default options, which can not be deleted.',
  'shareclassTable.delete.shareUsed':
    'The share is still used in {roundName}. Please change the round first.',
  'shareclassTable.columns.name': 'Share class',
  'shareclassTable.columns.type': 'Type',
  'shareclassTable.columns.seniority': 'Seniority',
  'shareclassTable.columns.details': 'Details',
  'shareclassTable.columns.lpInformation': 'LP Information',
  'shareclassTable.columns.notes': 'Notes',

  'shareclassTable.type.commonShares': 'Common Shares',
  'shareclassTable.type.options': 'Options',
  'shareclassTable.type.preferredShares': 'Preferred Shares',

  'shareclassTable.notes.noNotes': 'No notes saved',
  'shareclassTable.notes.showNotes': 'Show notes',
  'shareclassTable.antiDilution': 'Anti Dilution',
  'share.votingrights': 'Voting Rights',
  'payouts.current': 'Current Payouts',

  'capped.participation.help.title': 'Capping the revenue distribution of the share class',
  'capped.participation.help.excerpt':
    'Restriction of the share class in the exit participation up to a certain total amount. Afterwards usually a conversion of the share class will be made.',
  'capped.participation.NONE.SLP.help.title': 'No limitation',
  'capped.participation.NONE.SLP.help.excerpt':
    'This is the default for an non participating liquidation preference. The investor is not limited in case of a pro rata participation',
  'capped.participation.INVESTMENT_RETURN.SLP.help.title':
    'Limited to the total revenue of the share class',
  'capped.participation.INVESTMENT_RETURN.SLP.help.excerpt':
    'This is an unusual regulation. In the case of a creditable liquidation preference this has also no effect. No less than the investment amount or the preferential amount may be entered here.',
  'capped.participation.NONE.PLP.help.title': 'Investor-friendly option',
  'capped.participation.NONE.PLP.help.excerpt':
    'The share class receives no limit on the payout of the exit proceeds',
  'capped.participation.INVESTMENT_RETURN.PLP.help.title': 'Founder-friendly option',
  'capped.participation.INVESTMENT_RETURN.PLP.help.excerpt':
    'Limit the payout to the share class. Here a maximum total amount is entered, which is entitled to the share class. This is composed of the preference amount and the following pro rata participation',

  'shareclass.add.modal.info': 'Please specify all modalities of your individual shareclasses',
  'shareclass.add.modal.title.edit': 'Edit shareclass',
  'shareclass.add.modal.title': 'New shareclass',
  'shareclass.add.shareclass.button': 'Add Shareclass',
  'guidedTour.introSteps.shareclass.name': 'Shareclasses',
  'guidedTour.introSteps.shareclass.title': 'Shareclasses',
  'guidedTour.introSteps.shareclass.subtitle': 'Add your shareclasses',

  'revisionTable.usernameDisplay.supportNote':
    'This indicates that the field was updated due to a software upgrade.',
  'revisionTable.usernameDisplay.support': 'Ventury Software Update',
  'entity.CnConversion.date': 'Date of Deposit',
  'entity.CnConversion.share.name': 'Share class',
  'entity.EquityInvestment.date': 'Date of Deposit',
  'entity.EquityInvestment.share.name': 'Share class',
  'entity.Share.votingRights': 'Voting Rights',
  'investmentForm.date': 'Date of Deposit',
  'investmentForm.shareclass': 'Share class',
  'investmentForm.dateRequired': 'Please input a date',
  'investmentForm.shareclassRequired': 'Please select a shareclass',
  'excelliketable.import.edit.button': 'Add multiple',
  'equityInvestmentsTable.buttons.add': 'Add Equity Investment',
  'equityInvestmentsTable.buttons.edit': 'Edit Equity Investment',
  'roundDisplay.buttons.showCapTable': 'Show Cap Table',
  'equityInvestmentsTable.title': 'Equity Investments',
  'equityInvestmentsTable.quota.before': 'Before Round',
  'equityInvestmentsTable.quota.after': 'After Round',
  'shareholder.exceltable.error.name': 'Investor name must be given',
  'shareholder.exceltable.error.type': 'No valid Investor type selected',
  'shareholder.exceltable.error.email': 'Email has to conform with regular standards',
  'exceltable.rowInvalid': 'row not valid',
  'exceltable.cellError':
    'Error in row {rowNumber}, column {colNumber} with value "{value}" - {error}',
  'exceltable.ACTIONS': 'Actions',
  'exceltable.ID': 'Row',

  'termsheet.stillHasPayOut':
    'There still exists a payout level ({name}) where the investor participates. Please remove the payout first.',
  'termsheet.stillHasBuyOut':
    'The investor still has a buyout in the {roundName}. Please remove the buyout first.',
  'termsheet.stillHasDefaultInvestor':
    'The investor is still represented by {userName}. Please remove the reference first.',
  'termsheet.stillHasEsopGrant':
    'The investor still has granted esop shares in the {roundName}. Please remove the grants first.',
  'termsheet.stillHasEsop':
    'The investor is still is a Backer in an V(E)SOP Pool. Please change the V(E)SOP first.',
  'termsheet.stillHasConversions':
    'The investor still has conversions in {roundName}. Please remove the conversions first.',
  'termsheet.stillHasInvestment':
    'The investor still has an investment in {roundName}. Please remove the investment first.',

  'general.invitation': 'Invitation',
  'stakeholdersPage.acceptedInvitation':
    'The invitation got accepted and the user has access to the project.',
  companyURL: 'Company URL',
  'companyInfo.urlRequired': 'Company URL is required',
  // Translated (Malte 03.10.2020)
  'shareholder.initial.button': 'Add shareholders',
  'import.excel.heading': 'Import your existing shareholder via excel',
  'import.excel.subheading':
    'Just download our template and insert the required information in no time',
  'shareholder.active.transactions':
    'Deletion not possible, because the shareholder has active transactions',
  'guidedTour.introSteps.shareholder.name': 'Shareholders',
  'guidedTour.introSteps.shareholder.title': 'Shareholders',
  'guidedTour.introSteps.shareholder.subtitle': 'Add all your shareholders',
  'shareholder.add.modal.title': 'Add shareholder',
  'shareholder.add.modal.title.edit': 'Edit shareholder',
  'shareholder.add.modal.ok.edit': 'Save',
  'shareholder.modal.type': 'Type',
  'shareholder.table.delete.title': 'Are you sure you want to remove this shareholder?',
  'shareholder.type.required': 'Type required',
  'shareholder.add.shareholder.modal.content':
    'No shareholders have been created so far. Please click add shareholder.',
  'shareholder.add.shareholder.modal.title': 'Add shareholders',
  'shareholder.add.shareholder.button': 'Add shareholder',
  'stakeholder.importdata.info.1':
    'Add <b>all</b> shareholders who have invested or will invest in your company so far. You can edit this information at any time on the stakeholder page or in the Guided Tour',
  'stakeholder.importdata.info.2':
    'Use the table the way you are used to from Excel. Just copy and paste!',
  'stakeholder.importdata.info.3': 'Name and type are mandatory fields',
  'exceltable.upload.import.button': 'Import from template',
  'exceltable.template.download.button': 'excel template',
  'exceltable.upload.importFromTemplate.instructions.hint': 'Allowed file extension: .xls',
  'exceltable.upload.importFromTemplate.instructions.title':
    'Click or drag the prefilled template to this area',
  'exceltable.upload.importFromTemplate.title': 'Upload Template',
  'excelTable.importdata.title': 'Import Data',
  'excelTable.importdata.ok': 'Import Data',

  'entity.Share.liquidationPreference.customSharePrice': 'Alternative Share Price',
  'shareForm.liquidationPreference.customSharePrice': 'Alternative Share Price',
  'shareForm.liquidationPreference.customSharePriceQuestion': 'Fixed instead of Paid Price?',
  // Translated (Malte 09.09.2020)
  'verification.email.sent': 'Verification email sent',
  'verification.email.sent.desc': 'A new verification email has been sent to {email}',
  'verification.email.resendEmail': 'Send another verification email',
  // Translated (Jakob 07.09.2020)
  'billing.upgradeTemp.subject': 'Inquiry Ventury Analytics premium for founders',
  'billing.upgradeTemp.message':
    'I would like to get into contact to talk about Ventury Analytics premium for founders.',

  // Translated (Malte 31.08.2020)
  'valuationInput.roundPrice.label': 'Price',
  'enums.roundTypes.FOUNDING': 'Founding',
  'enums.roundTypes.BUYOUT': 'Buyouts Only',
  'enums.roundTypes.CONVERTIBLE_ONLY': 'Convertible Only',
  'enums.roundTypes.PRE_SEED': 'Pre Seed',
  'enums.roundTypes.SEED': 'Seed',
  'enums.roundTypes.SERIES_A': 'Series A',
  'enums.roundTypes.SERIES_B': 'Series B',
  'enums.roundTypes.SERIES_C': 'Series C',
  'enums.roundTypes.SERIES_D': 'Series D',
  'enums.roundTypes.SERIES_E': 'Series E',
  'enums.roundTypes.CUSTOM': 'Standard Round',

  'roundForm.type': 'Round Type',
  'roundForm.typeRequired': 'Please specify the type of this round',
  'roundForm.cashIn': 'Cash raised',
  'roundForm.cashInRequired': 'Please specify the amount invested in this round',
  'roundForm.cashInNotEqual':
    'The amount of cash raised ({cashIn}) is not equal to the sum of all investments ({totalInvestments}). Proceed if the post money valuation is correct',

  // Translated (Jakob 12.08.2020)
  'interestRateTable.totalAmount.hoverHelp.title': 'Preference Amount Calculation',
  'interestRateTable.totalAmount.hoverHelp.content.formula':
    'Total = Principal * Multiple + Interest',
  'interestRateTable.totalAmount.hoverHelp.content.calculation':
    '{total} = {principal} * {multiple} + {interest}',
  'interestRateTable.endDate.hoverHelp.title': 'Applied end date (limited by months)',
  'interestRateTable.endDate.hoverHelp.content':
    'The original end date {endDate} with applied limit of {limitInMonths} months.',
  'interestRateTable.interestAmount.hoverHelp.title': 'Calculation of the interest amount',
  'interestRateTable.interestAmount.hoverHelp.content.explain.principal':
    'Principal amount K ({principal})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.interestRate':
    'Interest rate i ({interestRate})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.time':
    'Time t in years ({time} = {days} days / {denominator})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.years':
    'Full years y ({years} = {days} days / {denominator} floored)',
  'interestRateTable.interestAmount.hoverHelp.content.explain.yearsRemaining':
    'Remaining years r ({yearsRemaining})',
  'interestRateTable.interestAmount.hoverHelp.content.formula': 'Interest = K * i * t',
  'interestRateTable.interestAmount.hoverHelp.content.formula.cumulative':
    'Interest = K * (1+i)^y * (1+(i*r)) - K',
  'interestRateTable.title': 'Preference Amounts Interest Calculations',
  'interestRateTable.nominal': 'Principal',
  'interestRateTable.interestRate': 'Interest rate',
  'interestRateTable.startDate': 'Start date',
  'interestRateTable.endDate': 'End date',
  'interestRateTable.days': 'Days',
  'interestRateTable.method': 'Method',
  'interestRateTable.interestAmount': 'Interest',
  'interestRateTable.totalAmount': 'Total',
  // Translated
  'investmentForm.amountOfShares': 'Amount of Shares',
  'investmentForm.amountOfSharesRequired': 'Please specify the amount of shares you want to assign',
  // Translated (Jakob 12.08.2020)
  'export.captable.filename': 'captable-ventury-export.xlsx',
  'export.waterfall.filename': 'waterfall-calculations-ventury-export.xlsx',
  // Newly translated (Jakob 08.08.2020)
  'extendedTable.searchBtn': 'Search',
  'extendedTable.resetBtn': 'Reset',
  // Newly translated (Jakob 24.07.2020)
  'percentOfMaxInput.otherFormat': '({value}{max})',
  'percentOfMaxInput.showMax': 'max. {max}',
  'termsheet.convertibleNoteEdit': 'Edit ConvertibleNote',
  'general.import.success': 'Successfully imported the project!',
  'general.import.failed': 'The import of the project failed. It might not be complete.',
  'general.import.failedModelling':
    'The import of the modelling projects failed. They might not be complete.',
  'tranchenForm.tranchenTable.dateOfDeposit': 'Date of deposit',
  'tranchenForm.tranchenTable.amount': 'Amount',
  'tranchenForm.tranchenTable.quota': '%',
  'tranchenForm.totalAmount': 'Total Amount',
  'tranchenForm.name': 'Tranche {idx}',
  'tranchenForm.customProps': 'Use other parameters than {name}',
  'tranchenForm.modalTitle': 'Convertible Note Tranches',
  'tranchenForm.errorTotalAmount': 'The total amount must equal the sum of all tranches',
  'tranchenForm.tranchenTable.converted': 'Total converted',
  'tranchenForm.tranchenTable.amount.error': 'Minimal converted',
  'tranchenForm.defaultPriceCalculationMethod': 'Price calculation method',
  'tranchenForm.defaultPriceCalculationMethod.isRequired':
    'Please select a price calculation method',
  'cn.roundName.short': 'CN {roundName}',
  'cn.roundName.long': 'Convertible Note {roundName}',
  'cn.nominal': 'Nominal amount',
  'cn.interest': 'Interest amount',

  'conversionForm.modalTitle': '{cnName} Conversion',
  'conversionForm.total.nominal': 'Total converted nominal',
  'conversionForm.total.interest': 'Total converted interest',
  'conversionForm.total.convertFullBtn.title': 'Full Conversion',
  'conversionForm.total.convertNoneBtn.title': 'Clear Conversion',
  'conversionForm.total.shares.label': 'Summary',
  'conversionForm.total.shares.text': 'Convert {conversionAmount} to {numberOfShares} shares',
  'conversionForm.trancheForm.fullConversion': 'Full conversion',
  'conversionForm.trancheForm.partialConversion': 'Partial conversion',
  'conversionForm.trancheForm.noConversion': 'No conversion',
  'conversionForm.trancheForm.emptyCn': 'Empty',
  'conversionForm.trancheForm.shares': 'to {numberOfShares} shares',
  'conversionForm.trancheForm.nominal': 'Converted nominal',
  'conversionForm.trancheForm.interest': 'Converted interest',

  // Translated
  'esop.pool.lowerThanMinAmountError':
    'The V(E)SOP size needs to be higher than the total amount of granted shares.',
  // Translated (Cheked by JAKOB, 15.07.2020 - v1.0.14)
  'waterfall.exactAmount': 'Show exact values',
  'menu.projectOverview': 'Overview of my projects',
  'menu.backToProject': 'Back to project {name}',
  'stepWiseExitTable.esopResiduals': 'V(E)SOP Residuals (unvested, unexercised or ungranted)',
  'stepWiseExitTable.esopResiduals.strikeResiduals':
    'V(E)SOP Residuals (payments from strike-prices)',
  // TRANSLATED (JAKOB)
  'groupPage.projects.join.disable':
    'Only projects with a group member that has admin or owner access rights can be joined.',
  'billing.earlyStagePremium.notification.title': 'Application for early-stage premium sent!',
  'billing.earlyStagePremium.notification.description':
    'You will soon receive an email with the confirmation.',
  'general.browserIncompatible':
    'Unfortunately, your browser does not support this feature. Please try another browser and report this to the support.',
  // PAYMENT SYSTEM (TODO)
  'billing.upgradeEnterprise.subject': 'Inquiry Ventury Analytics premium for enterprise',
  'billing.upgradeEnterprise.message':
    'I would like to get into contact to talk about Ventury Analytics premium for enterprises.',
  'billing.plans.enterprise.individualPrice': 'Contact us',
  'userProfile.groupInfo': 'Organization Information',
  'userProfile.groupName': 'Organization name',
  'userProfile.groupOwner': 'Organization administrator',
  'userProfile.leaveOrganization.toolTip': 'Leave the organization',
  'userProfile.leaveOrganization.confirm':
    'Are you sure you want to leave the organization? <br />' +
    'The access to joined projects remains for all organization members, but no new projects will be shared.  <br />' +
    'Further you will lose any premium access rights purchased by the organization.  <br />',

  'billing.earlyStagePremium.modal.title': 'Free Premium access to Ventury Analytics',
  'billing.earlyStagePremium.modal.description-1':
    'It seems that you are eligible for free access to our premium features.',
  'billing.earlyStagePremium.modal.description-2':
    'Use the scenario modelling tool and waterfall calculations for free.',
  'billing.earlyStagePremium.modal.description-3':
    'By clicking "OK" we redirect you to the billing page, where you can upgrade your startup account.',
  'billing.earlyStagePremium.modal.confirm':
    'We offer our software for free to german startups that have not exceeded 1 Mio in funding.',

  'adminDashboard.modalForm.validForDays': 'Package lifetime in days',
  'adminDashboard.modalForm.contingents': 'Number of granted contigents',
  'adminDashboard.modalForm.organizationType': 'Organization type',
  'adminDashboard.modalForm.noSuccess.message': 'Something went wrong, please contact the support',
  'adminDashboard.modalForm.success.message': 'Successfully granted a new package with contigents!',
  'organizationTypes.STARTUP': 'Startup',
  'organizationTypes.BUSINESS_ANGEL': 'Business Angel',
  'organizationTypes.SERVICE_PROVIDER': 'Service Provider',
  'organizationTypes.ENTERPRISE': 'Enterprise',

  'userAccount.group': 'Organization',
  'userAccount.group.packages': 'Packages',
  'adminDashboard.appliedPackages': 'Applied/Total valid Contigents',
  'adminDashboard.upgradeBtn': 'Grant Contigents',
  'adminDashboard.modalTitle': 'Grant Contigents to {userId}',

  'groupPage.pathName': 'Organization Management',
  'groupPage.members.organization': 'Organization',
  'groupPage.members.invite': 'Invite an organization member',
  'groupPage.members.membersTable.heading': 'Members',
  'groupPage.members.inviteTable.heading': 'Invited',
  'groupPage.packages.packagesTable.heading': 'Packages',
  'groupPage.organization.infoText':
    'This is your organization overview page. Here you can manage your members and activate premium access for your different projects.',
  'groupPage.members.infoText':
    'In the member area you can add and manage members of the organization. ' +
    'Every added member can now join all projects independently. ' +
    'They get the same access rights to the projects as you do.',
  'groupPage.packages.infoText':
    'In the Packges section you can see how many packages you have already purchased. ' +
    'You can also check how many contingents are still available in a package, when they expire and for which projects some of them have already been used. ',
  'groupPage.projects.infoText':
    'This is the overview of all projects belonging to the organization. By clicking on "Join" you can join as many projects as you like. ' +
    'Here you can also use your contingents to turn projects into premium projects. ' +
    'Please note that a contingent is consumed irrecoverably.',
  'groupPage.projects.upgradeProject.confirm':
    'Do you want to upgrade this project to premium? This will consume 1 contingent',

  'groupPage.members.inviteUser': 'Invite User',
  'groupPage.members.modal.checkRemoveFromProjects': 'Also remove from all organization projects',
  'groupPage.members.modal.confirmRemoval': 'Confirm Removal',
  'groupPage.members.modal.removalQuestion':
    'Do you want to remove this user from the organization?',
  'groupPage.invite.startupNotice':
    'Invite up to two additional co-founders or people from your startup. Please note that they need to have the same email-suffix (e.g. @your-bussiness.com). They will automatically be added to your project and have access to all the premium features!',
  'groupPage.invite.generalNotice':
    'Invite other members of your organization. You will have access to all created projects. Any organization member can join the projects. They do not have access to the administration page, only the organization creator administrates the premium upgrades.',
  'groupPage.invite.error.sameDomain':
    'Invitee must have the same email domain as the group owner.',
  'groupPage.invite.error.emailInvalid': 'Please enter a valid email address',
  'groupPage.invite.error.emailRequired': "Please enter the user's email",
  'groupPage.invite.error.emailExists': 'This email already exists',
  'groupPage.invite.error.startupLimitNotice': 'The startup package allows a maximum of 3 members',
  'groupPage.deleteMember.confirmation': 'Do you want to remove this user from the organization?',
  'groupPage.packages.orderId': 'Order Id',
  'groupPage.packages.contingents': 'Contingents',
  'groupPage.packages.boughtAt': 'Bought At',
  'groupPage.packages.validUntil': 'Valid Until',
  'groupPage.packages.usedBy': 'Used By',
  'groupPage.packages.project': 'Project',
  'groupPage.packages.usedAt': 'Used At',
  'groupPage.projects.column.companyName': 'Company Name',
  'groupPage.projects.column.operations': 'Join',
  'groupPage.projects.join': 'Join',
  'groupPage.projects.column.upgrade': 'Premium',
  'groupPage.projects.upgrade': 'Upgrade',
  'groupPage.projects.premium': 'Premium',
  'groupPage.projects.cardTitle': 'Organization projects',
  'groupInvitationPage.pathName': 'Organization Invite',
  'groupInvitationPage.accepted': 'You have accepted the organiation invitation!',
  'paywall.buyAdditionalPackage': 'Buy additional package',
  'paywall.premiumRequired': 'Premium Required',
  'paywall.premiumRequired.description': 'Upgrade your account to access this page',
  'paywall.contactOwner':
    "You don't have access to upgrade the project. Contact your organization manager to upgrade the project. ",
  'paywall.upgradeProject': 'Upgrade to premium',
  'paywall.noContingents': "You don't have any contingents.",
  'paywall.modal.title': 'Upgrade Project',
  'paywall.modal.description':
    'Upgrade the group access of the project to premium to use this feature. One contingent will be used when you upgrade.',
  'topBar.menu.organization': 'Organization Management',
  'premiumProjectStar.tooltip': 'Premium Project',
  'billing.actions.renew': 'Renew',
  'billing.actions.contact': 'Contact us',
  'billing.success.backToProject': 'Back to project',
  'billing.success.title': 'You successfully upgraded to premium!',
  'billing.success.description':
    'We received the payment confirmation and upgraded your account. View the organization details via the button in the topbar.',
  'billing.success.goGroup': 'View your organization page',
  'project.premiumAccessGranted': 'You have premium access to the project now!',
  'project.premiumAccess.contingentUsed': 'One contingent is used from your package.',
  'project.joined.message': 'You have joined the project!',
  'project.joined.description': 'Explore your stakeholder position in the company.',

  // Translated 23.06.2020
  'roundForm.noPostMoneyVal': 'Exclude Cash-in from Post-Money Valuation',
  'general.automatic': 'automatic',
  // Translated 27.04.2020
  'waterfall.calculationInfos': 'Calculation Information (IRR/Multiple)',
  'waterfall.totalInvestments': 'Total Investment Amount',
  'conversionPointSwitcher.totalPreferenceAmounts': 'Total Preference Amounts',
  'conversionPointSwitcher.conversionPoint': 'Conversion Point {name}',
  'conversionPointSwitcher.conversionPoints': 'Conversion Point of: {names}',
  'conversionPointSwitcher.label': 'Conversion Points',
  'payout.amount': 'Preference Amount',

  'stepWiseExitTable.title': 'Exit Distribution by Payout Levels',
  'stepWiseExitTable.columns.shareholder': 'Shareholder',
  'stepWiseExitTable.columns.equityholding': 'Shareholding (fully-diluted)',
  'stepWiseExitTable.columns.payoutLevel': 'Payout Level {level} {suffix}',
  'stepWiseExitTable.columns.remainingProceeds': 'Remaining Proceeds (Pro Rata)',
  'stepWiseExitTable.columns.totalProceeds': 'Total Proceeds',

  'exitRightTypes.LP': 'Liquidation Preference',
  'exitRightTypes.PAY_OUT': 'Payout',
  'exitRightTypes.CN_PAY_BACK': 'CN Payback',
  'exitRightTypes.DEBT_PAY_BACK': 'Debt Payback',
  'exitRightTypes.PRO_RATA_CAP': 'Pro Rata Cap',
  'exitRightTypes.PRO_RATA': 'Pro Rata',
  'exitRightTypes.SECONDARY': 'Secondary',
  'exitRightTypes.OTHER': 'Other',
  'exitRightTypesShort.LP': 'LP',

  // Translated 25.04.2020
  'revisionPage.pathName': 'Revisions',
  'revisionTable.columns.modifiedBy': 'Editor',
  'revisionTable.columns.entityRevTypes': 'Changes',
  'revisionTable.columns.revisionDate': 'Revision Date',
  'revisionTable.title.allChanges': 'Project Change History',
  'revisionTable.title.recentChanges': 'Most Recent Changes',

  'entityHistory.columns.modifiedBy': 'Editor',
  'entityHistory.columns.operation': 'Type of change',
  'entityHistory.columns.revisionDate': 'Revision Date',
  'entityHistory.entityDetails.previousValue': 'Original {type}',
  'entityHistory.entityDetails.newValue': 'New {type}',
  'entityHistory.showOnlyChanges.switch': 'Show only changes',

  'revisionType.ADD': 'Added',
  'revisionType.MOD': 'Edited',
  'revisionType.DEL': 'Deleted',

  'revisionTable.changeDisplay': '{revisionType} a{n} {entityName}',
  'revisionTable.usernameDisplay.noUser': 'Could not retrieve user. (Deleted?)',
  'revisionModal.title': 'Revision History for {suffix}',
  'entity.name': '{entityName} {name}',

  'entity.EsopSetup': 'Grant calculator setup',
  'entity.EsopSetup.exitAmount': 'Exit amount',
  'entity.EsopSetup.exitDate': 'Exit date',
  'entity.EsopSetup.defaultCompensationPeriodInMonths': 'Compensation period',
  'entity.EsopSetup.bonusCompensationLevels': 'Compensation levels',
  'entity.EsopSetup.bonusCompensationLevels.name': 'Level',
  'entity.EsopSetup.bonusCompensationLevels.percentFromSalary': '% of salary',

  'entity.Investor': 'Stakeholder',
  'entity.Investor.name': 'Name',
  'entity.Investor.type': 'Type',
  'entity.Investor.email': 'Email',
  'entity.Investor.jobTitle': 'Job title',
  'entity.Investor.salary': 'Salary p.a.',

  'entity.Company': 'Company',
  'entity.Company.name': 'Name',
  'entity.Company.sector': 'Sector',
  'entity.Company.location': 'Location',
  'entity.Company.companyURL': 'Company Website',
  'entity.Company.companyLogoURL': 'Company Logo',
  'entity.Company.exist': 'EXIST founded',
  'entity.Company.invest': 'INVEST founded',
  'entity.Company.districtCourt': 'District Court',
  'entity.Company.registrationNumber': 'Registration Number',
  'entity.Company.information': 'Information',
  'entity.Company.address.additional': 'Additional',
  'entity.Company.address.street': 'Street',
  'entity.Company.address.city': 'City',
  'entity.Company.address.postcode': 'Postcode',
  'entity.Company.address.country': 'Country',

  'entity.InvestmentRound': 'Investment round',
  'entity.InvestmentRound.date': 'Date',
  'entity.InvestmentRound.name': 'Name',
  'entity.InvestmentRound.preMoneyValuation': 'Pre-Money-Valuation',
  'entity.InvestmentRound.type': 'Type',
  'entity.InvestmentRound.cashIn': 'cashIn',
  'entity.InvestmentRound.share.name': 'Share',

  'entity.Share': 'Share',
  'entity.Share.name': 'Name',
  'entity.Share.seniority': 'Seniority',
  'entity.Share.text': 'Text',
  'entity.Share.liquidationPreference.multiple': 'LP Multiple',
  'entity.Share.liquidationPreference.simple': 'LP Participating',
  'entity.Share.liquidationPreference.simple.SLP': 'SLP',
  'entity.Share.liquidationPreference.simple.PLP': 'PLP',
  'entity.Share.liquidationPreference.agreedConversion': 'LP Agreed Conversion',
  'entity.Share.liquidationPreference.senior': 'LP senior',
  'entity.Share.liquidationPreference.capType': 'LP Cap Type',
  'entity.Share.liquidationPreference.cap': 'LP Cap',
  'entity.Share.liquidationPreference.interestRate.interestRate': 'LP Interestrate',
  'entity.Share.liquidationPreference.interestRate.cumulative': 'LP Cumulative Interest',
  'entity.Share.liquidationPreference.interestRate.accumulationType':
    'LP Interest Accumulation Type',
  'entity.Share.liquidationPreference.interestRate.retainDividends': 'LP Interest Retain Dividends',
  'entity.Share.liquidationPreference.interestRate.limitInMonths': 'LP Interest Limit in Months',
  'entity.Share.liquidationPreference.interestRate.limitAsDate': 'LP Interest Limit',
  'entity.Share.antiDilution.type': 'Anti-Dilution Type',
  'entity.Share.antiDilution.compensation': 'AD Compensation',
  'entity.Share.antiDilution.duration': 'AD Duration',
  'entity.Share.antiDilution.transferType': 'AD Transfer Type',

  'entity.PayOut': 'Payout',
  'entity.PayOut.name': 'Name',
  'entity.PayOut.seniority': 'Seniority',
  'entity.PayOut.amount': 'Amount',
  'entity.PayOut.receivers': 'Receivers',
  'entity.PayOut.receivers.name': 'Stakeholder',
  'entity.PayOut.distributionTable': 'DistributionTable',
  'entity.PayOut.distributionTable.investor.name': 'Stakeholder',
  'entity.PayOut.distributionTable.amount': 'Payout amount',

  'entity.BaseProject': 'Project',
  'entity.BaseProject.name': 'Name',
  'entity.BaseProject.roundingMode': 'Rounding method',
  'entity.BaseProject.currencyCode': 'Currency',
  'entity.BaseProject.simulateAD': 'Simulation of Anti-Dilution',

  'entity.ProjectDocument': 'Document',
  'entity.ProjectDocument.title': 'Title',
  'entity.ProjectDocument.dateAdded': 'Date of creation',
  'entity.ProjectDocument.uploader.firstname': 'User Firstname',
  'entity.ProjectDocument.uploader.lastname': 'User Lastname',

  'entity.ProjectMembership': 'Project Membership',
  'entity.ProjectMembership.projectRole': 'Project role',
  'entity.ProjectMembership.defaultInvestor.name': 'Represented Stakeholder',
  'entity.ProjectMembership.userAccount.firstname': 'User Firstname',
  'entity.ProjectMembership.userAccount.lastname': 'User Lastname',

  'entity.ProjectInvitation': 'Project Invitiation',
  'entity.ProjectInvitation.userEmail': 'Invitee email',
  'entity.ProjectInvitation.guestName': 'Invitee name',
  'entity.ProjectInvitation.projectRole': 'Project role',
  'entity.ProjectInvitation.defaultInvestor.name': 'Represented Stakeholder',

  'entity.EquityInvestment': 'Equity Investment',
  'entity.EquityInvestment.round.name': 'Round',
  'entity.EquityInvestment.investor.name': 'Stakeholder',
  'entity.EquityInvestment.amount': 'Amount',
  'entity.EquityInvestment.pricePerShare': 'Price per share',
  'entity.EquityInvestment.amountOfShares': 'Amount of Shares',
  'entity.EquityInvestment.vestingSchedule.cliff': 'Vesting cliff months',
  'entity.EquityInvestment.vestingSchedule.cliffPercent': 'Vesting cliff percent',
  'entity.EquityInvestment.vestingSchedule.accelerationOnExit': 'Vesting acceleration',
  'entity.EquityInvestment.vestingSchedule.startDate': 'Start date',
  'entity.EquityInvestment.vestingSchedule.percentUnderlyingVesting': 'Percent underlying vesting',
  'entity.EquityInvestment.vestingSchedule.schedule': 'Vesting schedule',
  'entity.EquityInvestment.vestingSchedule.schedule.percent': 'Vesting percent',
  'entity.EquityInvestment.vestingSchedule.schedule.months': 'Vesting months',
  'entity.EquityInvestment.vestingSchedule.schedule.vestingTime': 'Vesting interval',

  'entity.CnConversion': 'Convertible Note Conversion',
  'entity.CnConversion.round.name': 'Round',
  'entity.CnConversion.investor.name': 'Stakeholder',
  'entity.CnConversion.amount': 'Total Amount',
  'entity.CnConversion.amountOfShares': 'Amount of shares',
  'entity.CnConversion.interestAmount': 'Interest',
  'entity.CnConversion.pricePerShare': 'Price per share',

  'entity.CnInvestment': 'Convertible Note Investment',
  'entity.CnInvestment.round.name': 'Round',
  'entity.CnInvestment.investor.name': 'Stakeholder',
  'entity.CnInvestment.amount': 'Amount',
  'entity.CnInvestment.convertibleNote.discount': 'Discount',
  'entity.CnInvestment.convertibleNote.dateOfDeposit': 'Date of deposit',
  'entity.CnInvestment.convertibleNote.maturityDate': 'Maturity Date',
  'entity.CnInvestment.convertibleNote.preMoneyCap': 'Pre-Money-Valuation Cap',
  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion': 'Supplementary payment amount',
  'entity.CnInvestment.convertibleNote.interestRate.interestRate': 'CN Interestrate',
  'entity.CnInvestment.convertibleNote.interestRate.cumulative': 'CN Cumulative Interest',
  'entity.CnInvestment.convertibleNote.interestRate.accumulationType':
    'CN Interest Accumulation Type',
  'entity.CnInvestment.convertibleNote.interestRate.retainDividends':
    'CN Interest Retain Dividends',
  'entity.CnInvestment.convertibleNote.interestRate.limitInMonths': 'CN Interest Limit in Months',
  'entity.CnInvestment.convertibleNote.interestRate.limitAsDate': 'CN Interest Limit',
  'entity.CnInvestment.convertibleNote.share.name': 'Compensation Share',

  'entity.BuyOut': 'Buyout',
  'entity.BuyOut.round.name': 'Round',
  'entity.BuyOut.buyer.name': 'Buyer',
  'entity.BuyOut.seller.name': 'Seller',
  'entity.BuyOut.amount': 'Amount',
  'entity.BuyOut.pricePerShare': 'Price per share',
  'entity.BuyOut.buyingShare.name': 'Bought share',
  'entity.BuyOut.sellingShare.name': 'Sold share',
  'entity.BuyOut.vestingSchedule.cliff': 'Vesting cliff months',
  'entity.BuyOut.vestingSchedule.cliffPercent': 'Vesting cliff percent',
  'entity.BuyOut.vestingSchedule.accelerationOnExit': 'Vesting acceleration',
  'entity.BuyOut.vestingSchedule.startDate': 'Start date',
  'entity.BuyOut.vestingSchedule.percentUnderlyingVesting': 'Percent underlying vesting',
  'entity.BuyOut.vestingSchedule.schedule': 'Vesting schedule',
  'entity.BuyOut.vestingSchedule.schedule.percent': 'Vesting percent',
  'entity.BuyOut.vestingSchedule.schedule.months': 'Vesting months',
  'entity.BuyOut.vestingSchedule.schedule.vestingTime': 'Vesting interval',

  'entity.ManualShares': 'Manual Share Entry',
  'entity.ManualShares.name': 'Name',
  'entity.ManualShares.round.name': 'Round',
  'entity.ManualShares.share.name': 'Share',
  'entity.ManualShares.investor.name': 'Stakeholder',
  'entity.ManualShares.investment': 'Investment amount',
  'entity.ManualShares.price': 'Price',
  'entity.ManualShares.shares': 'Number of shares',
  'entity.ManualShares.isVirtualBacking': 'Virtual shares',
  'entity.ManualShares.notes': 'Notes',

  'entity.EsopCreation': 'V(E)SOP',
  'entity.EsopCreation.esop.name': 'Name',
  'entity.EsopCreation.esop.dilutionType': 'Dilution type',
  'entity.EsopCreation.esop.notes': 'Notes',
  'entity.EsopCreation.round.name': 'Round',
  'entity.EsopCreation.valuationType': 'Valuation type',
  'entity.EsopCreation.shareAmount': 'Poolsize',
  'entity.EsopCreation.backingTable': 'Backing table',
  'entity.EsopCreation.backingTable.investor.name': 'Stakeholder',
  'entity.EsopCreation.backingTable.numberOfShares': 'Number of shares',
  'entity.EsopCreation.defaultVestingSchedule.cliff': 'Default vesting cliff months',
  'entity.EsopCreation.defaultVestingSchedule.cliffPercent': 'Default vesting cliff percent',
  'entity.EsopCreation.defaultVestingSchedule.accelerationOnExit': 'Default vesting acceleration',
  'entity.EsopCreation.defaultVestingSchedule.schedule': 'Default vesting schedule',
  'entity.EsopCreation.defaultVestingSchedule.schedule.percent': 'Vesting percent',
  'entity.EsopCreation.defaultVestingSchedule.schedule.months': 'Vesting months',
  'entity.EsopCreation.defaultVestingSchedule.schedule.vestingTime': 'Vesting interval',

  'entity.EsopGrant': 'V(E)SOP Grant',
  'entity.EsopGrant.esop.name': 'V(E)SOP',
  'entity.EsopGrant.round.name': 'Round',
  'entity.EsopGrant.receiver.name': 'Receiver',
  'entity.EsopGrant.strikePrice': 'Strikeprice',
  'entity.EsopGrant.date': 'Granted Date',
  'entity.EsopGrant.expirationDate': 'Expiration Date',
  'entity.EsopGrant.shareAmount': 'Number of shares',
  'entity.EsopGrant.vestingSchedule.cliff': 'Vesting cliff months',
  'entity.EsopGrant.vestingSchedule.cliffPercent': 'Vesting cliff percent',
  'entity.EsopGrant.vestingSchedule.accelerationOnExit': 'Vesting acceleration',
  'entity.EsopGrant.vestingSchedule.startDate': 'Start date',
  'entity.EsopGrant.vestingSchedule.percentUnderlyingVesting': 'Percent underlying vesting',
  'entity.EsopGrant.vestingSchedule.schedule': 'Vesting schedule',
  'entity.EsopGrant.vestingSchedule.schedule.percent': 'Vesting percent',
  'entity.EsopGrant.vestingSchedule.schedule.months': 'Vesting months',
  'entity.EsopGrant.vestingSchedule.schedule.vestingTime': 'Vesting interval',
  'entity.EsopGrant.packageCalculation.packageValue': 'Package value',
  'entity.EsopGrant.packageCalculation.salaryCompensation': 'Salary compensation',
  'entity.EsopGrant.packageCalculation.bonusCompensation': 'Flexible bonus',
  'entity.EsopGrant.packageCalculation.compensationPeriodInMonths': 'Compensation period',
  'entity.EsopGrant.packageCalculation.percentOfPackageBackedByThisGrant':
    '% of package backed by grant',

  'date.today': 'Today',
  'date.yesterday': 'Yesterday',

  'd3.format.giga': 'B',

  'general.enabled': 'Enabled',
  'general.disabled': 'Disabled',

  // Translated Jakob (April 11th)
  'investmentForm.interestRate.types.title': 'Different Interestrate types',
  'investmentForm.interestRate.types.excerpt':
    'There are different definitions to calculate the interest rate. ' +
    'We support the 5 most common methods to calculate it on a yearly basis. ' +
    'For further information regarding the day count of the interest calculation please follow the link. ',
  'investmentForm.interestRate.types.link': 'https://www.investopedia.com/terms/d/daycount.asp',
  // Translated Jakob (April 6th)
  'payout.distributionTable.fullyDiluted': 'FD',
  'payout.distributionTable.fullyDiluted.title': 'Fully Diluted Share Quotas',
  'payout.distributionTable.fullyDiluted.excerpt':
    'Use the fully-diluted share quotas of the selected round to split the payout amount.',
  'payout.distributionTable.receivedAmount': 'Payout amount',
  'payout.distributionTable.quota': 'Payout quota',
  'termsheet.manualSharesDelete': 'Delete {name}',
  'termsheet.manualSharesAdd': 'Add Manual Share Entry',
  'termsheet.manualSharesEdit': 'Edit {name}',
  'termsheet.manualSharesModal.title': 'Manual share entry',
  'enums.eventTypes.MANUAL_SHARES': 'Manual Share Entry',
  'manualSharesForm.info':
    'This form provides the option to manually add a share entry. ' +
    'This can be useful e.g. for deviations in calculations or currently unsupported features. ' +
    'Simply enter a name and the number of shares to subtract/add. ' +
    'Optionally an investment or price can be associated with the entry. ' +
    'In case you want to operate virtual shares (e.g. V(E)SOP Backing), simply tick the checkbox. ' +
    'The share entry will be shown in the History-Trace and Cap-Table. ',

  'antiDilution.warning.title': 'Anti-Dilution Round',
  'antiDilution.warning.description':
    'We recognized a Downround due to lower valuation and calculated the Anti-Dilution. ' +
    'It will update when you change any information. ',
  'antiDilution.disabled': 'Disabled',
  'antiDilution.title': 'Triggered Anti-Dilution',
  'antiDilution.switch': 'Deviations in the calculations? Disable! ',
  'antiDilution.switch.hoverHelp.title': 'Disable Anti-Dilution for Historical Data',
  'antiDilution.switch.hoverHelp.excerpt':
    'If the automatically calculated Anti-Dilution has deviations to your calculations: ' +
    'Simply disable it and enter the information manually via "Options - Manual Shares Entry"',

  'manualSharesForm.negativeSharesError.message':
    'The stakeholder does not own enough shares of this type!',
  'manualSharesForm.negativeSharesError.description':
    'Please ensure that the stakeholder has enough shares, as negative shares are not possible.',
  manualSharesDisplay: 'Other',
  'manualSharesDisplay.notes': 'Notes',
  'manualSharesDisplay.isVirtualBacking': 'V(E)SOP Backing',
  'manualSharesForm.name': 'Name (E.g. Alternative Secondary)',
  'manualSharesForm.nameRequired': 'Please insert the name identifier.',
  'manualSharesForm.investment': 'Associated investment',
  'manualSharesForm.price': 'Associated price',
  'manualSharesForm.amountOfShares': 'Number of shares',
  'manualSharesForm.amountOfSharesRequired': 'Please insert the number of shares.',
  'manualSharesForm.shareType': 'Share type',
  'manualSharesForm.shareTypeRequired': 'Please select a share type',
  'manualSharesForm.isVirtualBacking': 'Shares are virtual (e.g. V(E)SOP Backing)',
  'manualSharesForm.notes': 'Notes (E.g. description)',

  // Translated Jakob (March 5th)
  'waterfall.payoutstructure.diagram.from': 'Participates from {exitAmount} Exit Amount',
  'waterfall.payoutstructure.diagram.total': 'Total',
  'waterfall.payoutstructure.diagram.title': 'Payout funnel',
  'termsheet.esop.label': 'V(E)SOPs',
  'esop.grant.max': '(Max. Poolsize - {poolSize}({poolSizePct}))',
  'bugReportPage.exportImportProject': 'Export/Import a Project (Admins only)',
  'bugReportPage.exportProject': 'Export Project',
  'bugReportPage.importProject': 'Import Project',
  'modellingPage.superForm.error.validForms':
    'The form still contains errors. The missing fields are marked red and listed below.',
  'modellingPage.superForm.error.emptyInvestors':
    'Please enter a name for the investor and remove all investors without any investments.',
  'modellingPage.superForm.error.cnOrEquitySelected':
    'Please select either a CN-Investment, an Equity-Investment or both for the financing round.',
  'modellingPage.superForm.error.equitySelected':
    'If you have the tab "Equity-Investment" is selected, you must have investors which have an equity investment. ' +
    'Otherwise please deselect it. (You might need to switch tabs first)',
  'modellingPage.superForm.error.cnSelected':
    'If you have the tab "Convertible-Note" is selected, you must have investors which have a convertible-note investment. ' +
    'Otherwise please deselect it. (You might need to switch tabs first)',

  // Translated Jakob (March 4th)
  'transactionTimeline.exitReturns': 'Exit Proceeds',
  'termsheet.parValueAdd': 'Add Par-Value-Investment',
  'termsheet.parValueEdit': 'Edit Par-Value-Investment',
  'termsheet.parValueDelete': 'Delete Par-Value-Investment',
  'termsheet.parValueDisplay.label': 'Par Value Shares',
  'termsheet.parValueModal.title': 'Par Value Shares',
  'parValueForm.sharesNumberRequired': 'Please enter the number of shares.',

  // Translated Jakob (March 2nd)
  'stakeholdersPage.inviteUser.success': '{name} got invited to the project.',
  'stakeholdersPage.inviteUser.success.description':
    'The user got notified by email and can accept the invitiation.',
  'stakeholdersPage.saveInvitation.success': 'The invitation of {name} got updated.',
  'stakeholdersPage.removeUser.success': 'User got removed from the project.',
  'stakeholdersPage.removeUser.success.description':
    'The user got notified by email and has no further access to the project.',
  'stakeholdersPage.revokeInvitation.success': 'The invitation for {email} got revoked.',
  'stakeholdersPage.revokeInvitation.success.description':
    'The user will be notified by email that the invitiation got canceled.',
  'stakeholdersPage.saveUser.success': 'The access rights of {name} got updated.',
  'stakeholdersPage.saveUser.success.description':
    'The user will be notified by email about the changes.',
  'stakeholdersPage.resendInvitation.success': 'Another email invitation got sent to {email}.',
  'stakeholdersPage.resendInvitation.success.description':
    'Please also notify the invited person to check the spam folder, if still no email has been received.',

  'general.beta': 'Beta',
  'termsheet.cnDelete': 'Delete Convertible Note',
  'termsheet.equityDelete': 'Delete Equity-Investment',
  // Translated Jakob (February 28th - 16:00)
  'bugReportPage.uniqueProjectId': 'Unique Project ID',
  'bugReportPage.uniqueProjectId.title': 'Unique Project ID',
  'bugReportPage.uniqueProjectId.excerpt':
    'A unique identifier for this project. On request you can provide it to the support to help them identify the problem.',
  'general.venturySupport': 'Ventury Support',
  'modellingPage.welcome.title.back': 'Continue your Modelling Projects',
  'modellingPage.welcome.title2.back': 'Select an existing project or create a new one',
  'modellingPage.tree.fieldNames.roundDate': 'Round Date',
  'date.validation.title': 'Date validation',
  'date.validation.excerpt':
    'The date needs to be after the previous round and before the next round. All invalid dates are disabled.',
  'modellingPage.superForm.scenarioCount.parentInfo':
    'Number of scenarios generated in total (multiplied by previous financing-round configuration).',
  'modellingPage.welcome.project.startNew': 'klick here to start new',
  'menu.upgradePremium.title': 'Premium required',
  'menu.upgradePremium': 'Upgrade your account to enable this feature',

  'esop.pool.byPriceAdjustment.info.title': 'Backed by old investors - price adjustment',
  'esop.pool.byPriceAdjustment.info.excerpt':
    'Discount the default round price for new investors by including the new V(E)SOP shares in the price calculation.',

  'modellingPage.analysis.details.scenario.infoText.title': 'Multiple scenarios',
  'modellingPage.analysis.details.scenario.infoText.excerpt':
    'There are multiple scenarios that had the same result. This can happen when parameters equalize (e.g. CN discount and pre-money-cap) or when higher error tolerances for share quotas/exit returns are applied. You can choose the scenarios based on their different parameters (in this round or one of the previous).',

  'modellingPage.superForm.nonEditableInvestors.title': 'New investors - non editable',
  'modellingPage.superForm.nonEditableInvestors.excerpt':
    'New investors are identified by their name and added to existing investors for future rounds. Thus the name is not editable.',

  'modellingPage.superForm.cnForcedConversion.title': 'Convertible Note assumptions',
  'modellingPage.superForm.cnForcedConversion.excerpt':
    'Convertible notes will be forcefully converted in the next equity-round based on the agreed valuation and round price with applied discounts and interest.',

  'modellingPage.superForm.priceCalculation.title': 'Price calculation',
  'modellingPage.superForm.priceCalculation.excerpt':
    'The round price is calculated based on the <b>Pre-Money-As-If-Converted Valuation</b> divided by the total number of <b>fully diluted shares</b>.',

  'modellingPage.superForm.esopPoolSize.title': 'V(E)SOP Pool',
  'modellingPage.superForm.esopPoolSize.excerpt':
    'The Percentage is based on the Post-Money-Pool of fully diluted shares and the pool is assumed to be backed by all shareholders. ',

  'modellingPage.analysis.rangeWarning.excerpt':
    'Scenarios which have the <b>same outcome (shareholding and exit proceeds)</b> for each investor are summarized as a <b>single result.</b> <br /> <br />' +
    'This can happen when parameters equalize (e.g. CN discount and pre-money-cap) or when they do not directly affect the shareholding/exit position.',

  'modellingPage.analysis.rangeWarning.multipleSummarized':
    '<b>{filteredResults} Filtered Results</b> are remaining after <b>{scenarios} Scenarios</b> were summarized to <b>{results} Results</b> and filters have been applied.',
  // Translated Jakob (February 23rd - 17:00)
  'modellingPage.analysis.rangeWarning.description1':
    'The results show the exit ranges based on the error-tolerance.',
  'modellingPage.analysis.rangeWarning.description2':
    'The graphs show one scenario that would score in the defined error-tolerance.',
  'modellingPage.analysis.rangeWarning.title': 'Multiple scenarios are summarized to one result.',

  'portfolio.info':
    'The portfolio page shows an overview of all companies you are a stakeholder in. ' +
    'If you have an investment it calculates you the IRR and multiples based on an exit as if the company would have been sold today to the last post money valuation. ' +
    'Click on the individual rows to see the last transactions.',
  'modellingPage.welcome.privateProject':
    'Modelling Projects are private and only you have access. Feel free to play around!',
  'verifyEmail.welcome': 'Welcome to Ventury Analytics!',
  'verifyEmail.description':
    "We've sent a verification link to your email address.<br/>Before you can continue, please click the verification link to finalize the signup process!",
  'verifyEmail.haveVerified': 'I have verified my account',
  'verifyEmailPage.pathName': 'Email verification',
  // Translated Jakob (February 22th - 17:00)
  payout: 'Payout',
  'modellingPage.tree.fieldNames.appliedDiscount': 'Applied Discount Parameter',
  'modellingPage.tree.fieldNames.appliedDiscount.preMoneyCap': 'Cap',
  'modellingPage.tree.fieldNames.appliedDiscount.discount': 'Discount',
  'modellingPage.tree.fieldNames.appliedDiscount.either':
    'Discount/Cap ({discount}, {preMoneyCap})',

  'guided.defaultPrice': 'Default Price for new Investments',
  'guided.customPrice': 'Custom Price',
  'conversionModal.conversionPrice': 'Price per Share (Discounted)',

  // Translated Jakob (February 21th - 10:00)
  'modellingPage.analysis.result.name': 'Result {idx}',
  'topBar.accountType': 'Account type:',
  'topBar.breadcrumbs.home': 'Home',
  'accountRights.SUPPORT': 'Support',
  'help.inviteSupport': 'Invite Support',
  'help.inviteSupport.confirm':
    'This will invite a member of the official Ventury Analytics Support Team to your project. <br />' +
    'They will have access to all your uploaded data. You can remove the support at any time via this page.',
  'help.inviteSupport.confirmation': 'The support is invited and will soon contact you!',

  // Translated by Jakob & Merlin (February 20th - 12:00)
  '404.description': 'The page is deprecated, deleted, or does not exist at all.',
  '404.goBack': 'Go back to the home page',
  '404.heading': 'Page not found',
  '404.pathName': 'Page Not Found',
  absolute: 'Absolute',
  'accessDeniedPage.button': 'Back to overview',
  'accessDeniedPage.description':
    'You can only access projects where you have sufficient privileges.',
  'accessDeniedPage.goBack': 'Back to overview',
  'accessDeniedPage.heading': 'Access Denied',
  'accessDeniedPage.pathName': 'Access Denied',
  'accessDeniedPage.reportBug': 'Report a bug',
  'accountRights.ADMIN': 'Admin',
  'accountRights.EDITOR': 'Editor',
  'accountRights.OWNER': 'Owner',
  'accountRights.VIEWER': 'Viewer',
  'accountRights.LIMITED_VIEWER': 'Limited Viewer',
  'accountRights.title': 'Account Rights',
  adPrice: 'AD Price',
  add: 'Add',
  addLow: 'add',
  'address.additional': 'Additional information',
  'address.city': 'ZIP, City',
  'address.country': 'Country',
  'address.street': 'Street, No.',
  'address.streetRequired': 'Please input a street',
  admin: 'Admin',
  after: 'after',
  amount: 'Amount',
  antiDilution: 'Anti-Dilution (AD)',
  autosave: 'Autosave',
  'billing.actions.current': 'Current Plan',
  'billing.actions.downgrade': 'Downgrade',
  'billing.actions.select': 'Choose Plan',
  'billing.actions.upgrade': 'Upgrade',
  'billing.choose': 'Choose your pricing plan',
  'billing.earlyStagePremium.confirm':
    'I hereby confirm that I use this software for a german start up that has not exceed 1 Mio in funding.',
  'billing.earlyStagePremium.description':
    'You are an early stage startup with less than one million financing? We offer you a free premium access. Simply apply.',
  'billing.earlyStagePremium.title': 'Early stage? Free upgrade!',
  'billing.pageTitle': 'Billing',
  'billing.pathName': 'Billing',
  'billing.plans.enterprise.description':
    'For professional investors to manage portfolio companies and plan financing rounds',
  'billing.plans.enterprise.features.1': 'All Premium Features',
  'billing.plans.enterprise.features.2': '2h Strategy consulting & Cap table onboarding',
  'billing.plans.enterprise.features.3':
    'Some clauses are not supported by the software? We model them for you!',
  'billing.plans.enterprise.features.4': '2+ projects & Priority support line',
  'billing.plans.enterprise.title': 'Investor Premium',
  'billing.plans.free.description':
    'For companies to easily manage your cap table and employee options',
  'billing.plans.free.features.1': 'Cap Table management',
  'billing.plans.free.features.2': 'Employee options',
  'billing.plans.free.features.3': 'Vesting plans',
  'billing.plans.free.features.4': 'Document filing',
  'billing.plans.free.title': 'Basic Account',
  'billing.plans.premium.description':
    'For companies which need optimal preparation in their financing rounds',
  'billing.plans.premium.features.1': 'All Basic Features',
  'billing.plans.premium.features.2': 'Financing Round Scenario Modeling',
  'billing.plans.premium.features.3': 'Waterfall analysis',
  'billing.plans.premium.features.4': 'Break Point Analysis & Exit Modelling',
  'billing.plans.premium.title': 'Startup Premium',
  'billing.pricePerPeriod': 'paid annually (excl. VAT)',
  'billing.underConstruction.callToAction': 'Get Premium!',
  'billing.underConstruction.description':
    'Ventury Analytics is currently closed access only.<br/> If you wish to access all of our premium features, please contact us directly!',
  'billing.upgradeAccount': 'Upgrade Account',
  'bugReportPage.descriptionPlaceholder':
    'Please describe the problem in detail, providing as much\ninformation as possible, including:\n- what happened and how were you affected\n- when did it happen, what actions did you do before that resulted in the issue\n- what platform are you using (operating system, browser version etc.)',
  'bugReportPage.descriptionRequired': 'Please describe the problem in detail',
  'bugReportPage.pathName': 'Report a Bug',
  'bugReportPage.problemTitle': 'Problem Title',
  'bugReportPage.problemTitlePlaceholder': 'Shortly state what happened - in a sentence or less...',
  'bugReportPage.problemTitleRequired': 'Please specify a problem title',
  'bugReportPage.report': 'Report Bug',
  'bugReportPage.success.description':
    'Thank you! We appreciate your contribution to the development of the platform and will address the problem as soon as possible.',
  'bugReportPage.success.message': 'Your report has been sent!',
  'bugReportPage.title': 'Report a Bug',
  buyOut: 'Buyout',
  'buyOutForm.buyOut': 'Buyout',
  'buyOutForm.buyer': 'Buyer',
  'buyOutForm.edit': 'Edit',
  'buyOutForm.numberOfShares': 'Number of shares',
  'buyOutForm.selectAnotherBuyer': 'Select another buyer',
  'buyOutForm.selectBuyer': 'Select a buyer',
  'buyOutForm.selectBuyingShare': 'Bought share',
  'buyOutForm.sell': 'Sell',
  'buyOutForm.sharesLeft': 'Shares left',
  calculate: 'Calculate',
  cancel: 'Cancel',
  'cancel-confirm': 'Sure to cancel?',
  cap: 'Cap',
  capPoint: 'Cap Point',
  'capTable.asIfConverted': 'As if converted: ',
  'capTable.capTableForRound': 'Cap Table {roundName}',
  'capTable.csv.columns.convertibleNote': 'Convertible Note',
  'capTable.csv.columns.equityHolding': 'Equityholding (fully diluted)',
  'capTable.csv.columns.esopBacking': 'V(E)SOP Backing',
  'capTable.csv.columns.name': 'Name',
  'capTable.csv.columns.newInvestment': 'New Investments',
  'capTable.csv.columns.newShares': 'New Shares',
  'capTable.csv.columns.shareholding': 'Shareholding (non-diluted)',
  'capTable.csv.columns.totalShares': 'Total Shares',
  'capTable.esopTotal': 'Fully-diluted share capital',
  'capTable.founderTotal': 'Founder Total',
  'capTable.fullHistoryTrace': 'Full History Trace',
  'capTable.investorTotal': 'Investor Total',
  'capTable.overview': '{roundName} Overview',
  'capTable.overviewPerRound': 'Investment Overview per Round',
  'capTable.pathName': 'Cap Table',
  'capTable.recap.cashRaised': 'Cash Raised',
  'capTable.recap.downRound': 'Down round',
  'capTable.recap.flatRound': 'Flat round',
  'capTable.recap.ifConverted': 'If Converted: {preMoney}',
  'capTable.recap.ownership': 'Ownership',
  'capTable.recap.postMoney': 'Post Money',
  'capTable.recap.preMoney': 'Pre-Money',
  'capTable.recap.preMoneyIncrease': 'Pre-Money Increase',
  'capTable.recap.sharePrice': 'Share Price',
  'capTable.recap.stakeholder': 'Stakeholder',
  'capTable.recap.upRound': 'Up round',
  'capTable.recap.valuationStep': 'Valuation Step',
  'capTable.title': 'Cap Table',
  'capTable.total': 'Total',
  'changelogPage.pathName': 'Changelog',
  clear: 'clear',
  clickToChange: 'Click to Change',
  clickToEdit: 'Click to insert a custom value',
  close: 'Close',
  collapse: 'collapse',
  'companyInfo.address': 'Address',
  'companyInfo.addressRequired': 'Please input a complete address',
  'companyInfo.dateLastRound': 'Last Date',
  'companyInfo.districtCourt': 'District Court',
  'companyInfo.existFounded': 'EXIST founded',
  'companyInfo.foundingDate': 'Founding Date',
  'companyInfo.furtherInfo': 'Further Information',
  'companyInfo.information': 'Additional Info',
  'companyInfo.informationPlaceholder': 'e.g. business purpose',
  'companyInfo.insertUserBusiness': 'Use same as user company',
  'companyInfo.investGrant': 'INVEST grant',
  'companyInfo.lastInvestment': 'Last Investment<br/>({name})',
  'companyInfo.lastRound': 'Last Round',
  'companyInfo.location': 'Location',
  'companyInfo.locationRequired': 'Please input a location',
  'companyInfo.longText':
    '<ins>{companyName}</ins> has raised <strong>{investment}</strong> in funding in {rounds} Rounds. Their last <ins>{lastRoundName}</ins> was closed on <em>{lastRoundDate}</em> with an amount of <strong>{lastRoundInvestments}</strong>.',
  'companyInfo.manually': 'add manually',
  'companyInfo.name': 'Company Name',
  'companyInfo.nameRequired': 'Please input your company name',
  'companyInfo.postMoneyVal': 'Post-Money Valuation<br/>({name})',
  'companyInfo.preMoneyVal': 'Pre-Money Valuation',
  'companyInfo.registrationNumber': 'Registration No.',
  'companyInfo.sector': 'Sector',
  'companyInfo.sectorRequired': 'Please input a sector',
  'companyInfo.shareholders': 'Shareholders',
  'companyInfo.title': 'Company Info',
  'companyInfo.totalRaised': 'Total Raised',
  compensation: 'Compensation',
  confirm: 'Confirm',
  convPoint: 'Conversion Point',
  conversion: 'Conversion',
  conversionVoluntary: 'Voluntary Conversion',
  conversions: 'Conversions',
  convertibleNote: 'Convertible Note',
  create: 'Create',
  cumulative: 'Compounding',
  date: 'Date',
  dateEntry: 'Entry Date',
  'dates.month': 'Month',
  'dates.months': 'Months',
  'dates.year': 'Year',
  defaultInvestor: 'Represented Investor',
  delete: 'Delete',
  deleteConfirm: 'Are you sure you want to delete {title}?',
  deleteLow: 'delete',
  deleteObj: 'Delete {name}',
  description: 'Description',
  detail: 'Detail',
  discount: 'Discount',
  dividend: 'Dividend',
  dividends: 'Dividends',
  'documents.documentDetails': 'Document Details',
  'documents.documentTitle': 'Document Title',
  'documents.empty': 'No documents uploaded...',
  'documents.enterMode.delete': 'Delete documents...',
  'documents.enterMode.edit': 'Edit documents...',
  'documents.fileExists.text':
    'A file with the same filename already exists. Do you want to override it?',
  'documents.fileExists.title': 'File already exists',
  'documents.instructions.hint':
    'Allowed file extensions: .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .xlm, .xlsm.<br/>You will be prompted to enter a document title',
  'documents.instructions.title': 'Click or drag your document to this area to upload',
  'documents.pageTitle': 'Documents',
  'documents.pathName': 'Documents',
  'documents.save': 'Save Document',
  'documents.search': 'Search documents...',
  'documents.titleRequired': 'Please enter the document title',
  'documents.upload': 'Upload Document',
  download: 'Download',
  drag: 'Drag',
  duration: 'Duration',
  'edge-user': 'Oh look a {name} user, we recommend using chrome or firefox instead!',
  edit: 'Edit',
  'edit.addCompany': 'Add the company',
  'edit.backToGuidedTour': 'Back to the Guided Tour',
  'edit.companyInfo': 'Company Info',
  'edit.deleteModelling': 'You can delete yours visiting the {link}',
  'edit.deleteProject': 'Delete Full Project',
  'edit.error.projectCorrupted.noCompany':
    'This project seems to be corrupted. Please contact our support.',
  'edit.error.projectDelete.modelling': 'You have to delete the modeling project first!',
  'edit.error.projectDelete.shared': 'You cannot delete a shared project!',
  'edit.financingRounds': 'Financing Rounds',
  'edit.projectDeleteConfirm':
    'Are you sure you want to delete the project? <br />' +
    'All data will be lost, including documents and modelling projects.  <br />' +
    'All invited shareholders will be notified that the project is deleted and have no further access.  <br />' +
    'If you activated premium features for this project, these features will be lost and not refundable.  <br />' +
    'This can not be undone.',
  'edit.projectInfo': 'Project Info',
  'edit.selectTermsheet.addRound': 'Add new round',
  editLow: 'edit',
  'editPage.pathName': 'Edit',
  editing: 'Edit',
  limitedViewer: 'Limited Viewer',
  email: 'Email',
  emptyResults: 'Empty results',
  'enums.accumulationTypes.Daily': 'Daily',
  'enums.accumulationTypes.Monthly': 'Monthly',
  'enums.accumulationTypes.Quarterly': 'Quarterly',
  'enums.accumulationTypes.Yearly_acc_acc': 'Yearly (act/act)',
  'enums.accumulationTypes.Yearly_acc_360': 'Yearly (act/360)',
  'enums.accumulationTypes.Yearly_30_360': 'Yearly (30/360 EU)',
  'enums.accumulationTypes.Yearly_US_360': 'Yearly (30/360 US)',
  'enums.accumulationTypes.Yearly_acc_365': 'Yearly (act/365)',
  'enums.accumulationTypesShort.Daily': 'p.d.',
  'enums.accumulationTypesShort.Monthly': 'p.m.',
  'enums.accumulationTypesShort.Quarterly': 'p.q.',
  'enums.accumulationTypesShort.Yearly_acc_acc': 'p.a. (act/act)',
  'enums.accumulationTypesShort.Yearly_acc_360': 'p.a. (act/360)',
  'enums.accumulationTypesShort.Yearly_30_360': 'p.a. (30/360 EU)',
  'enums.accumulationTypesShort.Yearly_US_360': 'p.a. (30/360 US)',
  'enums.accumulationTypesShort.Yearly_acc_365': 'p.a. (act/365)',
  'enums.antiDilutionCompensation.COMMON_SHARES': 'Common Shares',
  'enums.antiDilutionCompensation.DOWN_ROUND': 'Down Round',
  'enums.antiDilutionCompensation.INITIAL_INVESTMENT_ROUND': 'Initial Investment Round',
  'enums.antiDilutionDuration.INDEFINITE': 'Indefinite',
  'enums.antiDilutionDuration.NEXT_DOWN': 'Next Downround',
  'enums.antiDilutionDuration.NEXT_ROUND': 'Next Round',
  'enums.antiDilutionTransferTypes.CAPITAL_INCREASE': 'Capital Increase',
  'enums.antiDilutionTransferTypes.TRANSFER_SHARES': 'Transfer Shares',
  'enums.antiDilutionTypes.BROAD_BASED': 'Broad Based',
  'enums.antiDilutionTypes.FULL_RATCHET': 'Full Ratchet',
  'enums.antiDilutionTypes.NARROW_BASED': 'Narrow Based',
  'enums.capTypes.EXIT_VALUATION': 'Exit valuation',
  'enums.capTypes.INVESTMENT_RETURN': 'Investment return',
  'enums.capTypes.NONE': 'No Cap',
  'enums.shareholderTypesPlural.Business_Angel': 'Business Angels',
  'enums.shareholderTypesPlural.Corporate_Venture_Capitalist': 'Corporate Venture Capitalists',
  'enums.shareholderTypesPlural.ESOP_Pool': 'V(E)SOP Pools',
  'enums.shareholderTypesPlural.Employee': 'Employees',
  'enums.shareholderTypesPlural.Family': 'Families & Friends',
  'enums.shareholderTypesPlural.Founder': 'Founders',
  'enums.shareholderTypesPlural.Management': 'Management',
  'enums.shareholderTypesPlural.New_Investor': 'New Investors',
  'enums.shareholderTypesPlural.Venture_Capitalist': 'Venture Capitalists',
  'enums.eventTypes.BUY_OUT': 'Buyout',
  'enums.eventTypes.CN_CONVERSION': 'Conversion',
  'enums.eventTypes.CN_INVESTMENT': 'Convertible Note',
  'enums.eventTypes.DEBT_INVESTMENT': 'Debt',
  'enums.eventTypes.EQUITY_INVESTMENT': 'Equity Investment',
  'enums.eventTypes.ESOP_CREATION': 'V(E)SOP Creation',
  'enums.eventTypes.ESOP_GRANT': 'V(E)SOP Grant',
  'enums.eventTypes.SIM_ANTI_DILUTION': 'Anti Dilution',
  'enums.eventTypes.SIM_AUTO_CN_CONVERSION': 'Auto-Conversion',
  'enums.eventTypes.SIM_DIVIDENDS': 'Interest accumulation',
  'enums.exitReturnTypes.CAP_POINT': 'Cap point',
  'enums.exitReturnTypes.CONVERSION_POINT': 'Conversion point',
  'enums.exitReturnTypes.DEFAULT': 'Multiple',
  'enums.exitReturnTypes.MULTIPLE': 'Multiple',
  'enums.exitReturnTypes.PREFERENCE_AMOUNT': 'Preference amount',
  'enums.exitReturnTypes.STRIKE_POINT': 'Option Breakeven point',
  'enums.expertTypes.BEGINNER': 'Beginner',
  'enums.expertTypes.EXPERT': 'Expert',
  'enums.operationTypes.ADD': 'Add',
  'enums.operationTypes.ADD_DIVIDENDS': 'Add Dividends',
  'enums.operationTypes.RECEIVE_LP_RIGHTS': 'Received LP rights',
  'enums.operationTypes.SUB': 'Subtract',
  'enums.operationTypes.TRANSFER_LP_RIGHTS': 'Transferred LP rights',
  'enums.participationTypes.ConvertibleNote': 'Convertible Note Tranche',
  'enums.participationTypes.Debt_Capital': 'Debt Capital',
  'enums.participationTypes.Esop_Pool': 'V(E)SOP Pool',
  'enums.participationTypes.Exit_Money': 'Exit Money',
  'enums.participationTypes.GrantedShares': 'Granted Shares',
  'enums.participationTypes.Shares': 'Shares',
  'enums.userStatus.ADMIN': 'ADMIN-MODE',
  'enums.userStatus.SUPPORT': 'SUPPORT-MODE',
  'enums.userStatus.FREE': 'Free',
  'enums.roundingModes.CEILING': 'Ceil',
  'enums.roundingModes.FLOOR': 'Floor',
  'enums.roundingModes.HALF_UP': 'Nearest Integer',
  'enums.sectors.AGRICULTURE': 'Agriculture and farming',
  'enums.sectors.AUTOMOTIVE': 'Automobiles / Mobility / Logistics',
  'enums.sectors.CONSULTING': 'Consulting and agency',
  'enums.sectors.EDUCATION': 'Education',
  'enums.sectors.ENERGY': 'Energy and electricity',
  'enums.sectors.ENTERTAINMENT': 'Leisure, sport and (online) gaming',
  'enums.sectors.FINANCE': 'Banking and Finance/ Insurance',
  'enums.sectors.FOOD': 'Nutrition and food/consumer goods',
  'enums.sectors.HEALTH': 'Medicine and public health',
  'enums.sectors.HUMAN_RESOURCES': 'Human Resources',
  'enums.sectors.INDUSTRIAL_GOODS': 'Industrial goods',
  'enums.sectors.INFORMATION_TECHNOLOGY': 'Information and communication technology',
  'enums.sectors.LIFE_SCIENCE': 'Chemistry and pharmaceuticals/ biology',
  'enums.sectors.MEDIA': 'Media and creative industries',
  'enums.sectors.OTHER': 'Other',
  'enums.sectors.REAL_ESTATE': 'Real Estate',
  'enums.sectors.TEXTILE': 'Textile industry',
  'enums.sectors.TOURISM': 'Tourism',
  'enums.shareholderTypes.BUSINESS_ANGEL': 'Business Angel',
  'enums.shareholderTypes.CORPORATE_VENTURE_CAPITALIST': 'Corporate Venture Capitalist',
  'enums.shareholderTypes.ESOP_POOl': 'V(E)SOP Pool',
  'enums.shareholderTypes.EMPLOYEE': 'Employee',
  'enums.shareholderTypes.FAMILY': 'Family & Friends',
  'enums.shareholderTypes.FOUNDER': 'Founder',
  'enums.shareholderTypes.MANAGEMENT': 'Management',
  'enums.shareholderTypes.NEW_INVESTOR': 'New Investor',
  'enums.shareholderTypes.VENTURE_CAPITALIST': 'Venture Capitalist',
  'enums.shareholderTypes.Business_Angel': 'Business Angel',
  'enums.shareholderTypes.Corporate_Venture_Capitalist': 'Corporate Venture Capitalist',
  'enums.shareholderTypes.ESOP_Pool': 'V(E)SOP Pool',
  'enums.shareholderTypes.Employee': 'Employee',
  'enums.shareholderTypes.Family': 'Family & Friends',
  'enums.shareholderTypes.Founder': 'Founder',
  'enums.shareholderTypes.Management': 'Management',
  'enums.shareholderTypes.New_Investor': 'New Investor',
  'enums.shareholderTypes.Venture_Capitalist': 'Venture Capitalist',
  'enums.simulationRoundTypes.DOWN_ROUND': 'DOWN',
  'enums.simulationRoundTypes.FLAT_ROUND': 'FLAT',
  'enums.simulationRoundTypes.UP_ROUND': 'UP',
  equityHolding: 'Equityholding (fully diluted)',
  error: 'Error',
  'error.tryAgainOrSupport': 'Please try again, if the error remains contact our support.',
  'error.optionExists': 'This option already exists.',
  'errorPage.button': 'Back to overview',
  'errorPage.description': 'Please try again and consider filing a bug report.',
  'errorPage.heading': 'Oups, something went wrong. ',
  'errorPage.pathName': 'Error Notice',
  'errorPage.reportBug': 'Report a bug',
  'errorPage.timeout.button': 'Retry',
  'errorPage.timeout.description': 'Please check your network connection and try again.',
  'errorPage.timeout.heading': 'The server request timed out.',
  errorTitle: 'Ops error!',
  'errors.accessDeniedException.description': 'The access token is invalid or expired.',
  'errors.accessDeniedException.title': 'Access denied for server request.',
  'errors.arithmeticException.title':
    'The project seems corupted. Please contact our support and report the bug.',
  'errors.invitationRevokedException.description':
    'Please contact the owner of the project to share it with you.',
  'errors.invitationRevokedException.title': 'The invitation got revoked.',
  'errors.networkException.description': 'Please check your network connection and try again.',
  'errors.networkException.title': 'The server connection timed out.',
  'errors.optimisticLockException.description': 'Please try again.',
  'errors.optimisticLockException.title': 'Oups, something went wrong.',
  'esop.addGrant': 'Add grant',
  'esop.addPool': 'Add pool',
  'esop.available': 'Available Pool',
  'esop.backing.amountError':
    'The pool size exceeds the total number of shares in the company and can not be backed.',
  'esop.backing.backer': 'Backer of Existing VESOP',
  'esop.backing.backing': '% of backing',
  'esop.backing.backingError': 'Some investors do not own enough shares to back the pool.',
  'esop.backing.quotaError': 'The total sum of backed shares needs to equal the pool size.',
  'esop.backing.shares': '# V(E)SOP-shares backed',
  'esop.backing.title': 'Backing of {for}',
  'esop.backing.totals': 'totals',
  'esop.cliff': 'Cliff',
  'esop.deleteReferencedPool':
    '{title} still has grants. Are you sure you want to remove them as well?',
  'esop.editGrant': 'Edit grant - {name}',
  'esop.editPool': 'Edit pool - {name}',
  'esop.exercised': 'Exercised',
  'esop.expiredDate': 'Expired Date',
  'esop.fullyDiluted': 'Fully Diluted',
  'esop.grant.accerelation': 'Accerelation when exit',
  'esop.grant.addCliff': 'Add Cliff',
  'esop.grant.addCustomSchedule': 'Add new vesting entry',
  'esop.grant.addEmployee': 'Add a new employee',
  'esop.grant.amountLeft': 'left',
  'esop.grant.cliff': 'Cliff',
  'esop.grant.duration': 'Duration (in months)',
  'esop.grant.lastRoundPrice': 'Last round price {price}',
  'esop.grant.numberOfOptions': 'Number of options',
  'esop.grant.optional': 'optional',
  'esop.grant.saveEmployee': 'Save the employee',
  'esop.grant.to': 'To',
  'esop.grant.vesting': 'Vesting',
  'esop.grant.vestingStart': 'Vesting start date',
  'esop.grant.vests': 'Vests every (in months)',
  'esop.grantTitle': 'Grants for {for}',
  'esop.granted': 'Granted',
  'esop.hideBacking': 'Hide Backing',
  'esop.hideGrants': 'Hide Grants',
  'esop.modelling.grantedTable.columns.assigned': 'Assigned shares until {date} ',
  'esop.modelling.grantedTable.columns.exit': 'Exit Share Price ',
  'esop.modelling.grantedTable.columns.status': 'Status (inc. Acceleration)',
  'esop.modelling.grantedTable.columns.strikePrice': 'Strike price',
  'esop.modelling.grantedTable.columns.title': 'Board Member / Management / Key-Employees',
  'esop.modelling.grantedTable.months.plural': '({time} months)',
  'esop.modelling.grantedTable.months.singular': '({time} month)',
  'esop.modelling.grantedTable.status.nonVested': 'not vested',
  'esop.modelling.grantedTable.status.vested': 'vested',
  'esop.modelling.grantedTable.years.plural': '({time} years)',
  'esop.modelling.grantedTable.years.singular': '({time} year)',
  'esop.modelling.headerTable.fullyDilutedBasis': 'Fully diluted basis',
  'esop.modelling.headerTable.numberOfShares': 'Number of shares',
  'esop.modelling.headerTable.remaining': 'Remaining Shares',
  'esop.modelling.headerTable.totalAssigned':
    'Number of already assigned shares -vested and not vested-',
  'esop.modelling.headerTable.totalProposed': 'Number of proposed shares',
  'esop.modelling.headerTable.totalShares':
    'Total number of shares incl. virtual shares (Incentive Plans)',
  'esop.modelling.headerTable.totalVirtual': 'Total number of virtual shares (Incentive Plans)',
  'esop.name': 'Owner',
  'esop.pathName': 'V(E)SOP',
  'esop.pool.amount.info.title': 'Calculation of Pool Size',
  'esop.pool.amount.info1': 'The amount can be provided in percent of the total number of shares.',
  'esop.pool.amount.info2': 'The percentage is rounded to equal full shares.',
  'esop.pool.amount.info3':
    'The total number is based on the Pre-Money Pool or the Post-Money Pool (After investments).',
  'esop.pool.amount.info4':
    'If the Pool is backed by all investors, new shares are issued which increases the total sum of shares.',
  'esop.pool.amountHelp': 'Can be in both % or #',
  'esop.pool.backingBy': 'Backing by',
  'esop.pool.byBacking': 'Selected Investors',
  'esop.pool.byDilutionOfAll': 'All Investors',
  'esop.pool.byPriceAdjustment': 'All & Price adj.',
  'esop.pool.excludeShareholders': 'Exclude shareholders\nfrom dilution',
  'esop.pool.name': 'Pool Name',
  'esop.pool.notes': 'Notes',
  'esop.pool.postMoney': 'Post-Money Pool',
  'esop.pool.preMoney': 'Pre-Money Pool',
  'esop.pool.shareClassLabel': 'Share Class',
  'esop.pool.shareClassValue': 'Common Share (option)',
  'esop.poolTitle': 'Pools',
  'esop.showBacking': 'Show Backing',
  'esop.showGrants': 'Show Grants',
  'esop.strikePrice': 'Strike Price',
  'esopTable.title.long': 'Employee Stock Ownership Plans - V(E)SOPs',
  'esop.totalAgreed': 'Total agreed Pool',
  'esop.vested': 'Vested',
  'esop.vestingDuration': 'Vesting Duration',
  event: 'Event',
  eventRound: 'Event Round',
  eventType: 'Event Type',
  events: 'Events',
  exclude: 'Exclude',
  expand: 'expand',
  finish: 'Finish',
  fullyDilutedNote: '(fully diluted)',
  'general.comingSoon': 'Coming soon!',
  'guidedTour.addNewRound': 'Add a new round',
  'guidedTour.defaultProjectName': 'My Project-{num}',
  'guidedTour.finalSteps.finalCheck.name': 'Final Check',
  'guidedTour.finalSteps.finalCheck.subtitle': "Let's check if all your data is correct.",
  'guidedTour.finalSteps.finalCheck.title': 'We are almost finished.',
  'guidedTour.finalSteps.newRound.name': 'New Round',
  'guidedTour.finalSteps.newRound.subtitle': 'Add a new round or proceed to the final check.',
  'guidedTour.finalSteps.newRound.title': 'Any more historical rounds?',
  'guidedTour.finalSteps.sharing.name': 'Sharing',
  'guidedTour.finalSteps.sharing.skip': 'Or Skip',
  'guidedTour.finalSteps.sharing.subtitle':
    'Share your project with your lawyer or other shareholders.',
  'guidedTour.finalSteps.sharing.title': 'Share your Project.',
  'guidedTour.help.tutorialEnabled': 'Enable tutorial',
  'guidedTour.introSteps.companyInfo.name': 'Company Information',
  'guidedTour.introSteps.companyInfo.subtitle': ' ',
  'guidedTour.introSteps.companyInfo.title': 'Company Information',
  'guidedTour.introSteps.profile.name': 'Profile',
  'guidedTour.introSteps.profile.subtitle':
    'Fill in your profile information so other shareholder parties can identify you.',
  'guidedTour.introSteps.profile.title': 'Profile information',
  'guidedTour.loginNotification.description': 'You are redirected to the overview.',
  'guidedTour.loginNotification.message': 'You need to be logged in to create a project.',
  'guidedTour.pathName': 'Guided Tour',
  'guidedTour.proceedToFinal': 'Proceed to final check',
  'guidedTour.roundEnterPrevious':
    "It's time to enter your historical financing rounds step by step. (e.g. Founding, Pre Seed, Seed, etc.)",
  'guidedTour.roundNames.buyOut': 'Buyout',
  'guidedTour.roundNames.convertibleOnly': 'Convertible Only',
  'guidedTour.roundNames.create': 'Create New One',
  'guidedTour.roundNames.custom': 'Custom',
  'guidedTour.roundNames.defaults': 'Defaults',
  'guidedTour.roundNames.edit': 'Edit Round Name',
  'guidedTour.roundNames.founding': 'Founding',
  'guidedTour.roundNames.preSeed': 'Pre-Seed',
  'guidedTour.roundNames.seed': 'Seed',
  'guidedTour.roundNames.seriesA': 'Series A',
  'guidedTour.roundNames.seriesB': 'Series B',
  'guidedTour.roundNames.seriesC': 'Series C',
  'guidedTour.roundNames.seriesD': 'Series D',
  'guidedTour.roundNames.seriesE': 'Series E',
  'guidedTour.selectDefaultInvestor': 'Select Investor',
  'guidedTour.skipDashboard': 'Skip to Dashboards',
  'guidedTour.skipGuided': 'Skip',
  'guidedTour.start': 'Start',
  'guidedTour.title': 'Guided Tour',
  'guidedTour.tutorial.additionalRound.step1.content':
    'Name this round first and start afterwards with adding your valuation and the investment date. Different shares this time? Add a new one, if so.',
  'guidedTour.tutorial.additionalRound.step1.title': "Let's add some more details!",
  'guidedTour.tutorial.check.step1.content':
    "Everything alright? Then continue to your dashboards. Don't worry - You can edit the data anytime.",
  'guidedTour.tutorial.check.step1.title': 'Check your Cap Tables!',
  'guidedTour.tutorial.company.step1.content':
    'Let us give you a quick tutorial on the main features! If you already know your way around, you can always click the Skip button to dismiss it altogether',
  'guidedTour.tutorial.company.step1.title': 'Need some help?',
  'guidedTour.tutorial.company.step2.content':
    "Let's start by adding general information about the company whose cap table you want to create",
  'guidedTour.tutorial.newRound.step1.content':
    'If you raised more money than within the founding round, add a new round here.',
  'guidedTour.tutorial.newRound.step1.title': 'Finished yet?',
  'guidedTour.tutorial.round.step1.content':
    'We can now start by adding your founding. Start with the founding date!',
  'guidedTour.tutorial.round.step1.title': 'Perfect!',
  'guidedTour.tutorial.round.step2.content':
    'Normally Common Shares are issued when a company is founded. Otherwise, add a preferred share!',
  'guidedTour.tutorial.round.step2.title': 'Common Shares?',
  'guidedTour.tutorial.round.step3.content':
    'Add all your founders, business angels or others that were part of the founding with the "Add Shareholder" button',
  'guidedTour.tutorial.round.step3.title': 'Shareholders',
  'guidedTour.welcomePage.description':
    'In the next few minutes, we will guide you through all the necessary steps to initially set up your company profile and captable. You will need the information about your company structure and financing rounds.',
  'guidedTour.welcomePage.name': 'Welcome',
  'guidedTour.welcomePage.subtitle': "Let's create your company profile together!",
  'guidedTour.welcomePage.title': 'Welcome to',
  help: 'Help',
  'help.directSupport': 'Contact us',
  'help.documentation': 'Documentation (German)',
  'help.faq': 'FAQ (German)',
  'imageUpload.remove': 'Remove Image',
  'info.unsavedChanges.description': 'Please save to continue',
  'info.unsavedChanges.title': 'You have unsaved changes!',
  information: 'Information',
  interest: 'Interest',
  investment: 'Investment',
  investmentAmount: 'Investment Amount',
  'investmentForm.accumulationType': 'Accumulation type',
  'investmentForm.accumulationTypeRequired': 'Please select accumulation type',
  'investmentForm.amountRequired': 'Please enter amount',
  'investmentForm.convComplete': 'Complete Conversion',
  'investmentForm.convNoteAdd': 'Add Convertible Note',
  'investmentForm.convNoteLeft': 'Convertible Note left',
  'investmentForm.convPartial': 'Partial Conversion',
  'investmentForm.dateDeposit': 'Date of Deposit',
  'investmentForm.dateMaturity': 'Maturity Date',
  'investmentForm.defaultGroup': 'Default',
  'investmentForm.discountRequired': 'Please enter discount',
  'investmentForm.equityCapitalAdd': 'Add Equity Capital',
  'investmentForm.interestPercent': 'Interest (%)',
  'investmentForm.interestRequired': 'Please enter an interest rate',
  'investmentForm.limitAsDate': 'Limited interest period',
  'investmentForm.limitAsDateError': 'Please enter the end date for the interest calculations',
  'investmentForm.limitAsDateQuestion': 'Limited period?',
  'investmentForm.limitInMonths': 'Limited period (in months)',
  'investmentForm.limitInMonthsError': 'Please enter the number of months',
  'investmentForm.limitInMonthsQuestion': 'Limited period?',
  'investmentForm.maturityDateRequired': 'Please enter maturity date',
  'investmentForm.preMoneyCapRequired': 'Please enter pre-money-cap',
  'investmentForm.preMoneyFloorRequired': 'Please enter pre-money-floor',
  'investmentForm.pricePerShareRequired': 'Please enter price per share',
  'investmentForm.retainDividends': 'Retain interest rate upon conversion',
  'investmentForm.share': 'Received share',
  'investmentForm.shareConversionRound': 'Share in conversion round',
  'investmentForm.shareGroup': 'Shares',
  investmentTotal: 'Total Investment',
  investmentsNew: 'New Investments',
  investmentsTotal: 'Total Investments',
  investor: 'Investor',
  'investorForm.nameRequired': 'Please enter the name',
  'investorForm.roundRequired': 'Please select the entry round',
  'investorForm.typeRequired': 'Please select type',
  investorParticipating: 'Participating Investor',
  investors: 'Investors',
  left: 'left',
  liquidPref: 'Liquidation Preference (LP)',
  loading: 'Loading',
  'loadingType.add_user': 'Account Registration',
  'loadingType.authenticate': 'Authentication',
  'loadingType.done': 'All set up for you.',
  'loadingType.fetch_modelling': 'Loading your workspace',
  'loadingType.fetch_project': 'Loading your project',
  'loadingType.fetch_projects': 'Receiving your projects',
  'loadingType.fetch_token': 'Authorization',
  login: 'Login',
  logout: 'Logout',
  'menu.addProject': 'Add a new Project',
  'menu.adminDashboard': 'Admin Dashboard',
  'menu.benchmarking': 'Benchmarking',
  'menu.capTable': 'Cap Table',
  'menu.demoProject': 'Demo selected Project',
  'menu.documents': 'Documents',
  'menu.editProject': 'Edit Project',
  'menu.esop': 'V(E)SOP',
  'menu.esop.overview': 'Pools',
  'menu.esop.grantsOverview': 'Employee compensation',
  'menu.esop.grantModelling': 'Grant calculator',
  'menu.futureModelling': 'Future Modelling',
  'menu.language.de': 'German',
  'menu.language.en': 'English',
  'menu.overview': 'Overview',
  'menu.securities': 'Securities',
  'menu.settings': 'Settings',
  'menu.stakeholders': 'Stakeholder',
  'menu.vestingSchedules': 'Vesting Schedules',
  'menu.waterfallAnalysis': 'Waterfall Calculation',
  missingField: 'Missing {name} value',
  modelling: 'Modelling',
  'modellingPage.analysis.details.heading.intermediate': 'Round',
  'modellingPage.analysis.details.heading.previousCaptable': 'Previous Captable',
  'modellingPage.analysis.details.heading.result': 'Result',
  'modellingPage.analysis.details.heading.scenario': 'Scenario',
  'modellingPage.analysis.details.infoText':
    'Investigate details for the selected round. Rounds which had the same outcome are combined to one result (e.g. CN discount could result in the same outcome as a pre-money-cap).',
  'modellingPage.analysis.details.selectResult.placeholder': 'Select a result',
  'modellingPage.analysis.details.selectRound.placeholder': 'Select a round',
  'modellingPage.analysis.details.selectScenario.placeholder': 'Select a scenario',
  'modellingPage.analysis.details.tabs.captable': 'Cap table',
  'modellingPage.analysis.details.tabs.exitSimulation': 'Exit calculation (table)',
  'modellingPage.analysis.details.tabs.waterfall': 'Waterfall (graphic)',
  'modellingPage.analysis.filter.exits': 'Exits',
  'modellingPage.analysis.filter.exits.infix': 'receives an exit return of',
  'modellingPage.analysis.filter.exits.suffix': 'after an exit of',
  'modellingPage.analysis.filter.extended': 'Extended Filters',
  'modellingPage.analysis.filter.extended.exitTolerance.label':
    'Tolerable exit difference (error) per investor for grouping outcomes: ',
  'modellingPage.analysis.filter.extended.ignoreInvestors':
    'Select investors whos outcome is irrelevant: ',
  'modellingPage.analysis.filter.extended.infoText':
    'The extended filters allow you to ignore the outcome of specific investors and to group results by a defined error tolerance. If an investor is ignored and has two different share quotas and exit returns in two scenarios, they would still be summarized as one result in the tree and result selections. The error tolerances work similarly. If you apply a 5% error tollerance for the exit returns, then all scenarios where investors exit returns (for any exit amount) would lay within +/- 5% of the actual return would be summarized to one result. It works very similarly to histograms, the scenarios will be grouped by a defined range for the exit return/share quota. ',
  'modellingPage.analysis.filter.extended.shareTolerance.label':
    'Tolerable share difference (error) per investor for grouping outcomes: ',
  'modellingPage.analysis.filter.infoText':
    'Set any filters for share quotas or exit returns per shareholder and it will only show you the relevant results.',
  'modellingPage.analysis.filter.share': 'Shareholder',
  'modellingPage.analysis.filter.share.infix': 'holds a share quota of',
  'modellingPage.analysis.filter.share.suffix': 'after the investment.',
  'modellingPage.analysis.noSuperNodes':
    'No future financing rounds created.<br />Click on your latest financing round to add one.',
  'modellingPage.analysis.recalculating': 'Calculate {count}/{total} scenarios...',
  'modellingPage.analysis.results.diagram': 'Investors to show in diagram:',
  'modellingPage.analysis.results.infoText':
    'Compare different results by shareholder quotas, exit amounts or investment return rates.',
  'modellingPage.analysis.results.irrMultiple.investmentMultiple': 'Investment multiple: ',
  'modellingPage.analysis.results.irrMultiple.investmentVolume': 'Investment volume: ',
  'modellingPage.analysis.results.irrMultiple.investorDoesNotExit':
    'Investor does not exist in this scenario.',
  'modellingPage.analysis.results.irrMultiple.irr': 'IRR: ',
  'modellingPage.analysis.results.irrMultiple.totalExitRevenue': 'Total Exit Revenue: ',
  'modellingPage.analysis.results.tabs.irrMultiple': 'IRR & Multiple',
  'modellingPage.analysis.results.tabs.sharequota': 'Sharequota',
  'modellingPage.analysis.results.tabs.waterfall': 'Waterfall',
  'modellingPage.analysis.results.volumeTable': 'Total Investment Volumes',
  'modellingPage.analysis.resultsDisplay': 'Outcomes by Investor',
  'modellingPage.analysis.tabs.Details': 'Details',
  'modellingPage.analysis.tabs.filters': 'Filters',
  'modellingPage.analysis.tabs.results': 'Compare ({bucketNumber})',
  'modellingPage.bestScenarios': 'Best scenarios by exit amount',
  'modellingPage.cn': 'Convertible Note',
  'modellingPage.cnShort': 'CN',
  'modellingPage.debt': 'Debt',
  'modellingPage.equity': 'Equity Investment',
  'modellingPage.equityShort': 'Equity',
  'modellingPage.exitAmount': 'Exit Amount',
  'modellingPage.general': 'General Fields',
  'modellingPage.infos.analysis':
    'On the right side you will have an analysis section to compare the results. It is separated into 3 sections. A filter section, where you can reduce the number of results by setting required shareholder quotas or minimal exit amounts. A results section, that lets you compare the different outcomes for selected investors. You can choose to compare share quotas, investment returns or full waterfall exit distributions! In the Details section you can see the cap table of each round and dive into all the details of the simulation, such as valuation increase, triggered anti-dilutions or forced conversions. ',
  'modellingPage.infos.scenarios':
    'On the left side you will have the scenario tree. It has two options, one to edit the current tree and another to explore the results. You can switch between both options using buttons in the top bar. In the editing tree you can use the side menu to add, delete or edit nodes. In the result tree you have the different results visualized and can click on each node to show the captable! ',
  'modellingPage.infos.templates':
    'Predefined templates that help you with the most common use cases. Coming soon!',
  'modellingPage.resultParameters': 'Result parameters',
  'modellingPage.resultParameters.short': 'RP',
  'modellingPage.investorsTable': 'Investors Table - Equity/CN ({currency})',
  'modellingPage.investorsTable.short': 'IT',
  'modellingPage.menu.side.add': 'Add subsequent financing round',
  'modellingPage.menu.side.delete': 'Delete financing round',
  'modellingPage.menu.side.edit': 'Edit financing round',
  'modellingPage.menu.side.showDetails': 'Show details',
  'modellingPage.menu.top.analysis': 'Analysis Section',
  'modellingPage.menu.top.editing': 'Editing',
  'modellingPage.menu.top.project': 'Projects',
  'modellingPage.menu.top.results': 'Results',
  'modellingPage.menu.top.template': 'Templates',
  'modellingPage.menu.top.backToOverview': 'Back to overview',
  'modellingPage.menu.top.shareholders': 'Add shareholders',
  'modellingPage.menu.top.shareclasses': 'Add shareclasses',
  'modellingPage.pathName': 'Modelling and Simulation',
  'modellingPage.selectInvestor': 'Select Investor...',
  'modellingPage.selectInvestorToCompare':
    'Please select an  <span class="text-primary font-weight-bold">Investor</span> to compare.',
  'modellingPage.selectRound':
    'You need at least one <span class="text-primary font-weight-bold">Result</span> to compare them.',
  'modellingPage.superForm.addExisting': 'Add Existing',
  'modellingPage.superForm.cn.dateOfDeposit': 'Date of Deposit',
  'modellingPage.superForm.cn.discount': 'Discount',
  'modellingPage.superForm.cn.general': 'Cap & Discount',
  'modellingPage.superForm.cn.ir': 'Interest Rate',
  'modellingPage.superForm.cn.ir.accumulationType': 'Interest Method',
  'modellingPage.superForm.cn.ir.cumulative': 'Cumulative',
  'modellingPage.superForm.cn.ir.cumulative-non': 'Non Cumulative',
  'modellingPage.superForm.cn.ir.interestRate': 'Interest Rate',
  'modellingPage.superForm.cn.ir.limitInMonths': 'Limit In Months',
  'modellingPage.superForm.cn.ir.retainDividends': 'Retain Dividends',
  'modellingPage.superForm.cn.ir.retainDividends-non': "Don't Retain Dividends",
  'modellingPage.superForm.cn.maturityDate': 'Maturity Date',
  'modellingPage.superForm.cn.preMoneyCap': 'Pre Money Cap',
  'modellingPage.superForm.cnPercent': 'CN (%)',
  'modellingPage.superForm.createNew': 'Create New',
  'modellingPage.superForm.customOptionsLabel': 'New Investors',
  'modellingPage.superForm.equity.ad.short': 'AD',
  'modellingPage.superForm.equity.ad': 'Anti Dilution',
  'modellingPage.superForm.equity.ad.compensation': 'Compensation',
  'modellingPage.superForm.equity.ad.duration': 'Duration',
  'modellingPage.superForm.equity.ad.transferType': 'Transfer Type',
  'modellingPage.superForm.equity.ad.type': 'Type',
  'modellingPage.superForm.equity.lp.short': 'LP',
  'modellingPage.superForm.equity.lp': 'Liquidation Preference',
  'modellingPage.superForm.equity.lp.agreedConversion': 'Agreed Conversion',
  'modellingPage.superForm.equity.lp.agreedConversion-non': 'Non Agreed Conversion',
  'modellingPage.superForm.equity.lp.cap': 'Cap',
  'modellingPage.superForm.equity.lp.capType': 'Cap Type',
  'modellingPage.superForm.equity.lp.ir.short': 'IR',
  'modellingPage.superForm.equity.lp.ir': 'Interest Rate LP',
  'modellingPage.superForm.equity.lp.ir.accumulationType': 'Interest Method',
  'modellingPage.superForm.equity.lp.ir.cumulative': 'Cumulative',
  'modellingPage.superForm.equity.lp.ir.cumulative-non': 'Non Cumulative',
  'modellingPage.superForm.equity.lp.ir.interestRate': 'Interest Rate',
  'modellingPage.superForm.equity.lp.ir.limitInMonths': 'Limit In Months',
  'modellingPage.superForm.equity.lp.ir.retainDividends': 'Retain Dividends',
  'modellingPage.superForm.equity.lp.ir.retainDividends-non': "Don't Retain Dividends",
  'modellingPage.superForm.equity.lp.multiple': 'Multiple',
  'modellingPage.superForm.equity.lp.simple': 'Non Participating (SLP)',
  'modellingPage.superForm.equity.lp.simple-non': 'Participating (PLP)',
  'modellingPage.superForm.equity.preMoneyValuation': 'Pre Money Valuation',
  'modellingPage.superForm.equityPercent': 'Equity (%)',
  'modellingPage.superForm.error.fullInvestment':
    'The sum of equity and cn investments need to equal the total investment amount.',
  'modellingPage.superForm.esopPoolSize': 'V(E)SOP Pool Size',
  'modellingPage.superForm.existingOptionsLabel': 'Old Investors',
  'modellingPage.superForm.investmentByInvestor': 'Investment by Investor',
  'modellingPage.superForm.investor': 'Investor',
  'modellingPage.superForm.ir': 'Interest Rate',
  'modellingPage.superForm.name': 'Name',
  'modellingPage.superForm.proRata': 'Pro Rata amount based on cap table of {roundName} round.',
  'modellingPage.superForm.restAmount': 'Rest of the total investment amount.',
  'modellingPage.superForm.roundDate': 'Round Date',
  'modellingPage.superForm.scenarioCount': 'Scenario Count',
  'modellingPage.superForm.scenarioCount.info':
    'Number of scenarios generated by the configuration.',
  'modellingPage.superForm.totalInvestmentAmount': 'Total Investment Amount',
  'modellingPage.templates.baseScenario': 'Base Scenario',
  'modellingPage.templates.convertibleNote': 'Convertible Note',
  'modellingPage.templates.highScenario': 'High Scenario',
  'modellingPage.templates.lowScenario': 'Low Scenario',
  'modellingPage.topMenu.Delete': 'Delete',
  'modellingPage.topMenu.Delete-text':
    'Are you sure you want to delete the modelling project and all its content? This can not be undone.',
  'modellingPage.topMenu.Delete-title': 'Delete the modelling project {name}',
  'modellingPage.topMenu.Project': 'Projects',
  'modellingPage.topMenu.Template': 'Templates',
  'modellingPage.topMenu.createProject': 'Create a new modelling project',
  'modellingPage.topMenu.editProject': 'Edit modelling project',
  'modellingPage.topMenu.noProject': 'No projects',
  'modellingPage.topMenu.super-delete-text':
    'Are you sure you want to delete the finacing round and all its successor rounds? This can not be undone.',
  'modellingPage.topMenu.super-delete-title': 'Delete the financing round "{name}"',
  'modellingPage.tree.fieldNames.PLP': 'PLP',
  'modellingPage.tree.fieldNames.SLP': 'SLP',
  'modellingPage.tree.fieldNames.cap': 'Cap',
  'modellingPage.tree.fieldNames.cnInterest': 'CN-Interest',
  'modellingPage.tree.fieldNames.cumulative': 'Cumulative',
  'modellingPage.tree.fieldNames.discount': 'Discount',
  'modellingPage.tree.fieldNames.esop': 'V(E)SOP',
  'modellingPage.tree.fieldNames.investment': 'Investment',
  'modellingPage.tree.fieldNames.lpInterest': 'LP-Interest',
  'modellingPage.tree.fieldNames.monthLimit': 'Month limit',
  'modellingPage.tree.fieldNames.multiple': 'Multiple',
  'modellingPage.tree.fieldNames.noRanges': 'No Ranges',
  'modellingPage.tree.fieldNames.nonCumulative': 'Non-cumulative',
  'modellingPage.tree.fieldNames.ppS': 'Round price',
  'modellingPage.tree.fieldNames.preMoney': 'Pre-Money-Valuation',
  'modellingPage.tree.fieldNames.preMoneyCap': 'Pre-Money-Cap',
  'modellingPage.tree.fieldNames.withAndWithoutConversion': 'with & without conversion',
  'modellingPage.tree.fieldNames.withConversion': 'with converison',
  'modellingPage.tree.fieldNames.withoutConversion': 'without conversion',
  'modellingPage.welcome.blocked.noCapTable':
    'You need to have at least one round to start modelling.',
  'modellingPage.welcome.blocked.noShares':
    'You need to have at least one (legal) share in the company to start modelling.',
  'modellingPage.welcome.options1.info': 'create a',
  'modellingPage.welcome.options1.name': 'scenario tree',
  'modellingPage.welcome.options2.info': 'use our',
  'modellingPage.welcome.options2.name': 'base templates',
  'modellingPage.welcome.options3.info': 'explore the',
  'modellingPage.welcome.options3.name': 'analysis section',
  'modellingPage.welcome.project': 'PROJECT',
  'modellingPage.welcome.title': 'Welcome to the Modelling Page',
  'modellingPage.welcome.title2':
    'A playground to simulate future scenarios and evaluate the results!',
  multiple: 'Multiple',
  name: 'Name',
  new: 'New',
  next: 'Next',
  no: 'No',
  noCharts: 'No Diagrams to show...',
  noConversion: 'No conversion',
  noOptionsAvailable: 'No options available',
  non: 'non',
  none: 'None',
  number: 'number',
  ok: 'Ok',
  operations: 'Operations',
  optionalValueHide: 'Collapse',
  optionalValueRemove: 'Remove optional value',
  optionalValueShow: 'Insert optional value',
  options: 'Options',
  over: 'over',
  'overview.capTableOverview': 'Cap table overview',
  'overview.companyInfo': 'Executive summary',
  'overview.companyStructure': 'Company structure',
  'overview.delta': 'Delta',
  'overview.pathName': 'Overview',
  'overview.postMoney': 'Post-Money',
  'overview.preMoney': 'Pre-Money',
  'overview.valuationHistory': 'Valuation history',
  overwrite: 'Overwrite',
  owner: 'Owner',
  ownership: 'Ownership',
  page: 'Page',
  'pageNotice.createCompany': 'Create the company of the project',
  'pageNotice.createFinancingRound': 'Create a Financing Round',
  'pageNotice.createModelling': 'Create a Modelling Project',
  'pageNotice.createProject': 'Create a Project',
  'pageNotice.login': 'You need to login.',
  'pageNotice.noCharts': 'No Charts to show.',
  'pageNotice.noModellingBase': 'You need to have a Project to start modelling.',
  'pageNotice.noModellingProjects': 'No Modelling Projects available.',
  'pageNotice.noProjects': 'No Projects available.',
  'pageNotice.processingChanges': 'Processing changes...',
  'pageNotice.retryApplyChanges': 'Retry applying changes',
  'pageNotice.unlimitedProcessing': 'The connection timed out.',
  pariPassu: 'Pari Passu',
  participatingPref: 'Participating preferred (PLP)',
  'payout.add': 'Add Payout Level',
  'payout.deleteConfirm': 'Are you sure you want to delete this payout?',
  'payout.dragError.description':
    'Something went wrong while trying to re-orginize the order, try again!',
  'payout.dragError.seniorityDescription': "The {name} can't have seniority of 0.",
  'payout.dragError.seniorityTitle': "Can't do this",
  'payout.dragError.title': 'Could not save drag',
  'payout.editPayout': 'Edit Payout - {name}',
  'payout.editShare': 'Edit Share - {name}',
  'payout.level': 'Payout Level',
  'payout.multipleReceivers': 'Multiple Receivers',
  'payout.payoutLevel': 'Payout level (Seniority)',
  'payout.payoutReciver': 'Payout Reciever',
  'payout.receiver': 'receiver',
  'payout.receivers': 'Receivers',
  'payout.senioritySameError': "Payouts can't have same seniority level",
  'payout.singleReceiver': 'Single Receiver',
  'payout.title': 'Payout',
  'payout.types.PayOut': 'payout',
  'payout.types.Share': 'share-class',
  pending: 'pending',
  percent: 'Percent',
  'placeholder.end': 'End',
  'placeholder.fixed': 'Fixed',
  'placeholder.name': 'example-name',
  'placeholder.select': '-Select {name}-',
  'placeholder.selectSingle': 'Select',
  'placeholder.start': 'Start',
  'placeholder.step': 'Step Size',
  pleaseEnterA: 'Please enter a {name}',
  pleaseEnterAn: 'Please enter an {name}',
  pleaseEnter: 'Please enter {name}',
  pleaseInput: 'Please Input {name}',
  pleaseProvideA: 'Please provide a {name}',
  pleaseSelect: 'Please select {name}',
  pleaseSelectA: 'Please select a {name}',
  pleaseSelectOption: 'Please select one of the following options',
  'portfolio.IRR': 'IRR',
  'portfolio.chart.amount': 'Exit Return',
  'portfolio.chart.difference': 'Profit',
  'portfolio.chart.exitReturn': 'Exit Return',
  'portfolio.chart.monthly': 'By Month',
  'portfolio.chart.quarterly': 'By Quarter',
  'portfolio.chart.title': 'Summary of Investment-Returns',
  'portfolio.chart.totalInvestments': 'Total Investments',
  'portfolio.chart.weekly': 'By Week',
  'portfolio.chart.yearly': 'By Year',
  'portfolio.companyName': 'Company Name',
  'portfolio.currentProject': 'Current Project',
  'portfolio.lastPostMoneyValuation': 'Last Post-Money-Valuation',
  'portfolio.multiple': 'Multiple',
  'portfolio.my': 'My Projects',
  'portfolio.pathName': 'Portfolio',
  'portfolio.selectDefaultInvestor': 'Select which stakeholder position you represent',
  'portfolio.selectDefaultInvestorFor': 'Select which stakeholder you represent for {companyName}',
  'portfolio.shared': 'Shared Projects',
  'portfolio.switchProject': 'Switch to this project',
  'portfolio.title': 'Portfolio',
  'portfolio.totalInvestment': 'Total Investment',
  postMoneyVal: 'Post-Money-Valuation',
  preMoneyCap: 'Pre-Money-Cap',
  preMoneyFloor: 'Pre-Money-Floor',
  preMoneyVal: 'Pre-Money-Valuation',
  preMoneyValAsIfConverted: 'Pre-Money-Valuation (as-if-converted)',
  premium: 'Premium',
  previous: 'Previous',
  price: 'Price',
  pricePaid: 'Paid Price',
  pricePerShare: 'Price per share',
  'project.currency': 'Project Currency',
  'project.name': 'Project name',
  'project.nameRequired': "Please input the project's name",
  'project.roundingMode': 'Rounding mode',
  'project.title': 'project',
  'projectInvitationPage.pathName': 'Project Invitation',
  provideName: 'Please provide a name',
  quota: 'Quota',
  'range.set': 'Set Range',
  'range.step': 'Step Size',
  'reactJoyride.back': 'Back',
  'reactJoyride.close': 'Close',
  'reactJoyride.last': 'Last',
  'reactJoyride.next': 'Next',
  'reactJoyride.skip': 'Skip',
  readMore: 'Read More',
  recalculate: 'Recalculate',
  recalculating: 'Recalculating',
  relative: 'Relative',
  reportBug: 'Report a Bug',
  round: 'Round',
  roundDate: 'Round Date',
  'roundForm.currentInvestments': 'Current investments: {total}',
  'roundForm.dateRequired': 'Please input a date',
  'roundForm.postMoneyRequired': 'Please enter post money valuation greater total investments',
  'roundForm.preMoneyValAsConverted': 'Info: {amount} (as-if-converted)',
  'roundForm.roundNameRequired': 'Please enter round name',
  'roundForm.shareAdd': 'Add new Share',
  'roundForm.shareDelete': 'Delete Share',
  'roundForm.shareEditSelected': 'Edit selected Share',
  'roundForm.shareNew': 'New Share',
  'roundForm.shareRound': 'Share Class',
  'roundForm.shareUsedError': 'Error deleting the share, the share is still used in {roundName}!',
  'roundForm.totalInvestmentsAdd': 'Add total investments',
  roundPrice: 'Round Price',
  save: 'Save',
  saveAndCalculate: 'Save & Calculate',
  saved: 'Saved',
  saving: 'Saving',
  'securities.esop': 'Fully diluted',
  'securities.excludeFounders': 'Exclude Founder-Vesting',
  'securities.exit': 'Exit Event',
  'securities.investorPerspective': 'Investor Perspective',
  'securities.investorShares': 'Investor Ownership',
  'securities.pathName': 'Securities',
  'securities.payoutStructure': 'Payout Structure',
  'securities.sharePerspective': 'Share Perspective',
  'securities.shareTypesOwnership': 'Share Types and Ownership',
  'securities.shares': 'Investor shares',
  'securities.slider': 'Share distributions in different scenarios',
  'securities.specialRights': 'Special Rights',
  'securities.title': 'Securities',
  'securities.vested': 'Vesting applied',
  selectedProject: 'Selected Project',
  senior: 'Senior',
  seniority: 'Seniority',
  seniotityLevel: 'Seniority Level',
  series: 'Series',
  'settings.description':
    'This Settings component provides the ability to construct custom blocks with any widgets, components and elements in them, like these theme settings.',
  'settings.isBorderless': 'Borderless design',
  'settings.isFixedWidth': 'Fixed width',
  'settings.isLightTheme': 'Light topic',
  'settings.isSquaredBorders': 'Square edges',
  'settings.menuCollapsed': 'Collapsed menu',
  'settings.menuShadow': 'Menu shadow',
  'settings.menuTop': 'Top menu (horizontal)',
  'settings.title': 'Themes Settings',
  share: 'Share',
  'shareForm.cappedPartRequired': 'Please select the cap type',
  'shareForm.cappedParticipation': 'Capped Participation',
  'shareForm.compensationRequired': 'Please select compensation',
  'shareForm.durationRequired': 'Please select duration',
  'shareForm.multipleRequired': 'Please enter multiple',
  'shareForm.nameRequired': 'Please enter share name',
  'shareForm.participationCap': 'Participation Cap',
  'shareForm.payoutHide': 'Hide Payout',
  'shareForm.payoutPreview': 'Payout Preview',
  'shareForm.seniorLastInFirstOut': 'Senior (Last in First Out)',
  'shareForm.seniorityRequired': 'Please enter share seniority',
  'shareForm.simpleRequired': 'Please select the LP type',
  'shareForm.text': 'Notes',
  'shareForm.defaultPriceCalculationMethod': 'Price calculation method',
  'shareForm.defaultPriceCalculationMethod.isRequired': 'Please select a price calculation method',
  'shareForm.transferType': 'Transfer Type',
  'shareForm.transferTypeRequired': 'Please select transfer type',
  'shareForm.typeRequired': 'Please select type',
  shareHolding: 'Shareholding (non-diluted)',
  shareQuota: 'Share quota',
  shareholder: 'Shareholder / Investor',
  'shareholder-types.plural.business_angel': 'Business Angels',
  'shareholder-types.plural.corporate_venture_capitalist': 'Corporate VCs',
  'shareholder-types.plural.employee': 'Employees',
  'shareholder-types.plural.esop_pool': 'V(E)SOPs',
  'shareholder-types.plural.esop': 'V(E)SOPs',
  'shareholder-types.plural.family': 'Family & Friends',
  'shareholder-types.plural.founder': 'Founders',
  'shareholder-types.plural.investor': 'Investors',
  'shareholder-types.plural.management': 'Managements',
  'shareholder-types.plural.sim_investor': 'New Investors',
  'shareholder-types.plural.new_investor': 'New Investors',
  'shareholder-types.plural.venture_capitalist': 'Investors',
  'shareholder-types.singular.business_angel': 'Business Angel',
  'shareholder-types.singular.corporate_venture_capitalist': 'Investor',
  'shareholder-types.singular.employee': 'Employee',
  'shareholder-types.singular.esop_pool': 'V(E)SOP',
  'shareholder-types.singular.family': 'Family',
  'shareholder-types.singular.founder': 'Founder',
  'shareholder-types.singular.investor': 'Investor',
  'shareholder-types.singular.management': 'Management',
  'shareholder-types.singular.venture_capitalist': 'Investor',
  shareholderDefault: 'Default Shareholder',
  shareholders: 'Shareholders',
  shares: 'Shares',
  sharesEsop: '# V(E)SOP Shares',
  sharesNew: 'New Shares',
  sharesNumber: 'Number of Shares',
  'sharesOverview.ownership-esop': 'Ownership (fully diluted)',
  'sharesOverview.ownership-exit': 'Ownership (at exit)',
  'sharesOverview.ownership-granted': 'Ownership (inc. granted)',
  'sharesOverview.ownership-shares': 'Ownership (non diluted)',
  'sharesOverview.ownership-vested': 'Ownership (inc. vested)',
  'sharesOverview.ownershipDiluted': 'Quota (fully diluted)',
  'sharesOverview.sharesOutstanding': 'Outstanding Shares',
  'sharesOverview.sharesOutstanding-esop': 'Outstanding Shares (fully diluted)',
  'sharesOverview.sharesOutstanding-exit': 'Outstanding Shares (at exit)',
  'sharesOverview.sharesOutstanding-granted': 'Outstanding Shares (inc. granted)',
  'sharesOverview.sharesOutstanding-shares': 'Outstanding Shares (non diluted)',
  'sharesOverview.sharesOutstanding-vested': 'Outstanding Shares (inc. vested)',
  'sharesOverview.sharesOutstandingDiluted': 'Outstanding Shares (inc. vested)',
  sharesTotal: 'Total Shares',
  simple: 'Non Participating (SLP)',
  simulation: 'Simulation',
  'specialRightsOverview.empty': 'No series with preference rights',
  'specialRightsOverview.sharesComp': 'Compensation Shares',
  'specialRightsOverview.simplePref': 'Non Participating',
  'stakeholdersPage.accessRightInfos': 'Access Rights Information',
  'stakeholdersPage.accessRights': 'Access Rights',
  'stakeholdersPage.accessRightsRequired': "Please specify the user's access rights",
  'stakeholdersPage.addName': 'Or add name',
  'stakeholdersPage.addUser': 'Add a new User',
  'stakeholdersPage.admin.three':
    'Rights to edit and delete documents, which were created by the account',
  'stakeholdersPage.admin.six': 'Editing Page',
  'stakeholdersPage.admin.five':
    'All members of the organization (e.g. VC/Co-Founders) can access the project',
  'stakeholdersPage.admin.one': 'All Viewer Rights',
  'stakeholdersPage.admin.four': 'Can invite other users (Viewers, Admins and Support)',
  'stakeholdersPage.admin.two': 'Rights to edit and delete project data',
  'stakeholdersPage.adminRights': 'Admins can modify the project and additionally invite viewers.',
  'stakeholdersPage.alreadyInvited': 'This user has already been invited',
  'stakeholdersPage.bystandingUsers': 'Bystanding Users',
  'stakeholdersPage.detail': 'Detail',
  'stakeholdersPage.limitedViewer.one': 'E.g. Employee only has access to his grant position',
  'stakeholdersPage.limitedViewer.three': 'All other company data can not be accessed',
  'stakeholdersPage.limitedViewer.two': 'E.g. Investor, only has access to his investment position',
  'stakeholdersPage.limitedViewerRights':
    'Limited viewers can only see their own position in the company.',
  'stakeholdersPage.emailExists': 'This email already exists',
  'stakeholdersPage.emailInvalid': 'Please enter a valid email address',
  'stakeholdersPage.emailRequired': "Please enter the user's email",
  'stakeholdersPage.guestNameLabel': 'First and Last name',
  'stakeholdersPage.guestNameRequired': 'Please provide a guest name',
  'stakeholdersPage.invitationResent': 'Re-sent Invitation',
  'stakeholdersPage.invite': 'Invite',
  'stakeholdersPage.inviteUser': 'Invite new User',
  'stakeholdersPage.owner.four': 'Can invite new users (inc. Admins, Owners)',
  'stakeholdersPage.owner.one': 'All Admin Rights',
  'stakeholdersPage.owner.three': 'Can delete the whole project',
  'stakeholdersPage.owner.two': 'Can change access rights of others',
  'stakeholdersPage.owner.five': 'Rights to edit and delete all documents',
  'stakeholdersPage.ownerRights':
    'Owners of a project have the rights to delete the project and modify or revoke users access rights.',
  'stakeholdersPage.pathName': 'Stakeholders',
  'stakeholdersPage.provideAccessRights': 'Please provide an Access Right',
  'stakeholdersPage.removeSelf': 'Remove Yourself',
  'stakeholdersPage.removeSelfConfirm': 'This will remove yourself from the project, proceed?',
  'stakeholdersPage.removeUser': 'Remove User',
  'stakeholdersPage.removeUserConfirm': 'Do you want to remove this user from the project?',
  'stakeholdersPage.resend': 'Resend',
  'stakeholdersPage.revokeInvitation': 'Revoke Invitation',
  'stakeholdersPage.revokeInvitationConfirm': 'Do you want to revoke the invitation for this user?',
  'stakeholdersPage.stakeholders': 'Stakeholders',
  'stakeholdersPage.thatsme': "That's me",
  'stakeholdersPage.title': 'Stakeholders',
  'stakeholdersPage.userSelectRequired': 'Please select an existing investor or add a new user',
  'stakeholdersPage.viewer.four': 'Can create a private Modelling Project',
  'stakeholdersPage.viewer.one': 'Overview, Securities and Document Page',
  'stakeholdersPage.viewer.three': 'Stakeholder, V(E)SOP & Vesting Page',
  'stakeholdersPage.viewer.two': 'Cap Table Page, History & Waterfall Calculation',
  'stakeholdersPage.viewerRights':
    'Viewers can only view the project permanently, they are not allowed to modify the project.',
  sum: 'Sum',
  'termsheet.buyOutAdd': 'Add Buyouts',
  'termsheet.buyOutDelete': 'Delete Buyout',
  'termsheet.buyOutDeleteBy': 'Delete Buyout by',
  'termsheet.buyOutEdit': 'Edit Buyouts',
  'termsheet.collapseHeaderError': 'Please fill all missing fields & save',
  'termsheet.conversionAdd': 'Add Conversions (CN {roundName})',
  'termsheet.conversionDelete': 'Delete Conversions (CN {roundName})',
  'termsheet.conversionEdit': 'Edit Conversions (CN {roundName})',
  'termsheet.deleteInvestorsError':
    'You first need to delete the new investments, buyouts and esop-pools of this round!',
  'termsheet.disabledConversionDelete':
    'You can only delete the conversions after removing the buyout of the shares.',
  'termsheet.disabledConversionEdit':
    'You can only edit the conversions after removing the buyout of the shares.',
  'termsheet.conversionExceeded': 'Conversion amount exceeds investment',
  'termsheet.investorDelete': 'Delete Investor',
  'termsheet.prevQuota': 'Prev. Quota',
  'termsheet.roundDelete': 'Delete Round',
  'termsheet.roundDeleteConfirm': 'Are you sure you want to delete the round?',
  'termsheet.roundDeleteDisabledFounding': 'You can not delete the founding round.',
  'termsheet.roundDeleteDisabled': 'You can only delete your last round.',
  'termsheet.stillHasBuyOutError':
    'Error deleting the investor, it still has a buyout in the {roundName}!',
  'termsheet.stillHasDefaultInvestorError':
    'Error deleting the investor, it is still represented by {userName}. Please remove the reference first.',
  'termsheet.stillHasEsopGrantError':
    'Error deleting the investor, it still has an granted esop shares in the {roundName}!',
  'termsheet.stillHasEsopError':
    'Error deleting the investor, it still is a Backer in an V(E)SOP Pool!',
  'termsheet.stillHasConversionsError':
    'Error deleting the convertible note, it still has conversions in {roundName}!',
  'termsheet.stillHasInvestmentError':
    'Error deleting the investor, it still has an investment in {roundName}!',
  'termsheet.thatsMe': "That's me!",
  'termsheet.valuationInput.help.cn':
    'Buying-power by {investorName} ({nominal} nominal + {dividends} interest (over {days} days) discounted by {discount} and {forcedPaymentOnConversion} price reduction)',
  'termsheet.valuationInput.help.description':
    'The Pre-Money-Valuation as-if-converted is calculated on the basis of accounting for all convertible notes including their interest and discounts through caps and discount parameters. The interest of the convertible notes is calculated based on the days between the investment date and the {date}.',
  'termsheet.valuationInput.help.title': 'Pre-Money-As-If-Converted Calculation',
  today: 'Today',
  'topBar.menu.editProfile': 'Edit Profile',
  'topBar.menu.hello': 'Hello, {name}',
  'topBar.menu.helloNoLogin': 'Hello, Newby!',
  'topBar.menu.noLoginNotice': 'Login or make an account to see more.',
  'topBar.menu.portfolio': 'Portfolio',
  'topBar.menu.upgradePremium': 'Get Premium',
  'topBar.typeToSearch': 'Type to search...',
  'topBar.version': 'Software version {version}',
  total: 'Total',
  totalResult: 'Total Result',
  'tree.investment': 'Investment',
  'tree.postMoney': 'Post-Money Valuation',
  'tree.preMoney': 'Pre-Money Valuation',
  'triggeredEvents.antiDilution': 'The Anti-Dilution triggers because it was a Down Round.',
  'triggeredEvents.forcedConversion':
    'The conversion happened, because during simulation all convertible notes are forcefully converted in the next round.',
  type: 'Type',
  undefined: 'N/A',
  'underConstruction.description':
    'This site is currently under construction or you have no access to this site within the demo version.',
  underConstructionPage: 'Under Construction',
  'userProfile.accountType': 'Account Type',
  'userProfile.avatar': 'Profile Avatar',
  'userProfile.avatarRemove': 'Remove Profile Avatar',
  'userProfile.city': 'City',
  'userProfile.companyDetails': 'Company Information of current employment',
  'userProfile.companyLogo': 'Company Logo',
  'userProfile.companyLogoRemove': 'Remove Company Logo',
  'userProfile.companyName': 'Company Name',
  'userProfile.country': 'Country',
  'userProfile.deleteAccount.confirmation':
    'Are you sure you want to delete your account on Ventury Analytics?<br/>All project data will be permanently lost.',
  'userProfile.deleteAccount.title': 'Delete Account',
  'userProfile.firstName': 'First name',
  'userProfile.generalInfo': 'General Information',
  'userProfile.lastLogin': 'Last login',
  'userProfile.lastName': 'Last name',
  'userProfile.lastUpdate': 'Last profile update',
  'userProfile.pageTitle': 'Profile',
  'userProfile.passwordReset.confirmation': 'Are you sure you want to reset your password?',
  'userProfile.passwordReset.description':
    'A password reset link has been sent to your email address. Please follow the instructions as provided there!',
  'userProfile.passwordReset.message': 'Check your email!',
  'userProfile.passwordReset.title': 'Reset Password',
  'userProfile.pathName': 'Profile',
  'userProfile.personalInfo': 'Personal Information',
  'userProfile.postcode': 'Postcode',
  'userProfile.profileActions': 'Profile Actions',
  'userProfile.sendNewsletter': 'Send Newsletter',
  'userProfile.signupTime': 'Registration date',
  'userProfile.streetNumber': 'Street and Number',
  'userProfile.title': 'Job Title',
  valuation: 'Valuation',
  'vesting.confirmDeletion': 'You want to delete the vesting schedule?',
  'vesting.editVesting': 'Edit Vesting Schedule - {name}',
  'vesting.numberOfUnvestedShares': 'Number of unvested shares',
  'vesting.pathName': 'Vesting',
  'vesting.remainingVestingTime': 'Remaining Vesting Time',
  'vesting.select': 'show',
  'vesting.unselect': 'hide',
  'vesting.unvestedShares': 'Unvested Shares',
  'vesting.vestedShares': 'Vested Shares',
  viewer: 'Viewer',
  warning: 'Warning',
  'waterfall.breakpointAnalysis': 'Breakpoint Analysis',
  'waterfall.calculationInfos.general':
    'In the calculations for the IRR we consider the following transactions and payouts with irregular investment intervals (XIRR).',
  'waterfall.calculationInfos.notes':
    'Notes: The IRR and multiple is not calculated for Employee-Options, because the option is only executed at the exit date. An alternative multiple could be calculated as the difference to the potentially paid strike price.',
  'waterfall.customExitValue': 'Custom Exit Value',
  'waterfall.distributeResiduals': 'Distribute V(E)SOP Residuals Pro Rata',
  'waterfall.distributeResiduals.confirm':
    'This will distribute the residual amounts to all pro-rata participants according to their legal share quota. <br />Please be aware that this might outdate conversion & cap points. Thus we recommend leaving it disabled. ',
  'waterfall.dividendsShare': 'Dividends per Share',
  'waterfall.effectiveCapPoint': 'Effective Cap Point',
  'waterfall.exitDateLabel': 'Date of exit',
  'waterfall.exitRevenue.investorBased': 'Investor based Exit Revenue',
  'waterfall.exitRevenue.shareBased': 'Share based Exit Revenue',
  'waterfall.hidePreview': 'Hide Preview',
  'waterfall.investmentMultiple': 'Investment Multiple',
  'waterfall.irr': 'IRR',
  'waterfall.irr.transactionList': 'Transaction list',
  'waterfall.irr.transactionsError':
    'Could not find transactions for the investor for a specific scenario.',
  'waterfall.irrInvestments': 'Investment types included in IRR transactions',
  'waterfall.irrInvestments.four': 'Convertible note investment',
  'waterfall.irrInvestments.one': 'Equity Investment',
  'waterfall.irrInvestments.three': 'Secondary (Buyer)',
  'waterfall.irrInvestments.two': 'Anti-Dilution (Capital Increase)',
  'waterfall.irrPayOuts': 'Payout types included in IRR transactions',
  'waterfall.irrPayOuts.one': 'Pay out (e.g. catch ups)',
  'waterfall.irrPayOuts.three': 'Secondary (Seller)',
  'waterfall.irrPayOuts.two': 'LP-, Dividend- (LP/CN) and grant exit returns',
  'waterfall.noPoints': 'No cap or conversion points',
  'waterfall.noPointsShow': 'There are no cap or conversion points to show',
  'waterfall.noPrefAmount': 'No preferred amounts',
  'waterfall.pathName': 'Waterfall Calculation',
  'waterfall.prefAmount': 'Preferred Amount',
  'waterfall.prefAmountShare': 'Preferred Amount per Share / Payout',
  preview: 'Preview',
  'waterfall.pricePerShare': 'Price per Share (Exit)',
  'waterfall.printAmount.LP': '{amount} LP-Amount',
  'waterfall.printAmount.dividends': '{amount} Dividends-Amount',
  'waterfall.printAmount.exit': '{amount} Exit-Amount',
  'waterfall.printAmount.proRata': '{amount} Pro-Rata-Amount',
  'waterfall.proRataAmount': 'Pro Rata Amount',
  'waterfall.proRataShare': 'Pro Rata per Share',
  'waterfall.prorata': 'Pro Rata',
  'waterfall.strikePointAnalysis': 'Employee-Options Breakeven analysis',
  'waterfall.strikePointAnalysis.noPoints':
    'No grants with strike prices, thus no strike points to show.',
  'waterfall.strikePointAnalysis.shareAmount': 'Share Amount',
  'waterfall.strikePointAnalysis.strikePoint': 'Break-even point',
  'waterfall.strikePointAnalysis.strikePrice': 'Strike Price',
  'waterfall.targetExit': 'Target Exit (in M{currency})',
  'waterfall.title': 'Liquidation Preference',
  'waterfall.totalExitRevenue': 'Total Exit Revenue',
  'waterfall.exitAmount': 'Exit amount',
  'waterfall.totalIssued': 'Total Issued',
  'waterfall.undefinedIrr':
    'The IRR could not be calculated, because it exceeded the number of iterations. Often this happens when the exit date is to close to the last founding round.',
  waterfallAnalysis: 'Waterfall Calculation',
  yes: 'Yes',
}

export default {
  locale: 'en-US',
  antdData,
  messages,
}
